var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g2, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g3, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g4, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g5, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _g6, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _g7, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g8, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _g9, _path262, _path263, _path264, _path265, _path266, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessControlsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 251,
    viewBox: "0 0 358 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.732 130.977C261.981 130.977 261.261 130.82 260.713 130.506L233.144 114.552C232.549 114.207 232.228 113.713 232.228 113.163C232.228 112.528 232.675 111.901 233.449 111.454L239.146 108.159C240.516 107.367 242.519 107.288 243.716 107.987L271.285 123.941C271.88 124.286 272.201 124.78 272.201 125.329C272.201 125.965 271.755 126.592 270.98 127.039L265.283 130.334C264.54 130.765 263.616 130.985 262.724 130.985L262.732 130.977ZM241.713 108.292C240.954 108.292 240.148 108.473 239.537 108.826L233.841 112.12C233.324 112.418 233.011 112.803 233.011 113.148C233.011 113.493 233.301 113.72 233.535 113.862L261.104 129.816C262.051 130.365 263.781 130.279 264.892 129.643L270.589 126.341C271.105 126.043 271.418 125.659 271.418 125.314C271.418 124.968 271.129 124.741 270.894 124.6L243.325 108.645C242.902 108.402 242.323 108.285 241.713 108.285V108.292Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.632 170.777C253.88 170.777 253.16 170.62 252.613 170.306L238.613 162.203C238.018 161.858 237.697 161.364 237.697 160.815C237.697 160.18 238.143 159.552 238.918 159.105L242.447 157.058C243.817 156.266 245.82 156.187 247.017 156.885L261.017 164.988C261.612 165.333 261.933 165.827 261.933 166.376C261.933 167.012 261.487 167.639 260.712 168.086L257.183 170.133C256.439 170.565 255.516 170.785 254.624 170.785L254.632 170.777ZM245.014 157.199C244.255 157.199 243.449 157.379 242.839 157.74L239.309 159.787C238.793 160.085 238.48 160.47 238.48 160.815C238.48 161.152 238.769 161.388 239.004 161.529L253.004 169.631C253.951 170.181 255.68 170.094 256.791 169.459L260.321 167.412C260.837 167.114 261.15 166.729 261.15 166.384C261.15 166.047 260.861 165.812 260.626 165.67L246.626 157.568C246.204 157.324 245.624 157.207 245.014 157.207V157.199Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.146 184.919C238.324 184.919 237.503 184.731 236.869 184.362L199.252 162.596C198.571 162.203 198.195 161.654 198.195 161.05C198.195 160.446 198.571 159.897 199.252 159.505L242.855 134.271C244.131 133.534 246.142 133.534 247.417 134.271L266.496 145.315L266.105 145.998L247.026 134.954C246.001 134.365 244.272 134.365 243.246 134.954L199.643 160.187C199.22 160.431 198.978 160.752 198.978 161.058C198.978 161.364 199.22 161.678 199.643 161.929L237.26 183.696C238.285 184.284 240.015 184.284 241.04 183.696L316.688 139.919C317.111 139.676 317.354 139.354 317.354 139.048C317.354 138.742 317.111 138.429 316.688 138.178L244.6 96.4639C243.575 95.8756 241.846 95.8756 240.821 96.4639L196.012 122.396C195.589 122.639 195.347 122.96 195.347 123.266C195.347 123.572 195.589 123.886 196.012 124.137L209.66 132.036C210.34 132.428 210.716 132.977 210.716 133.581C210.716 134.185 210.34 134.734 209.66 135.126L182.99 150.563C181.715 151.308 179.712 151.3 178.428 150.563L148.511 133.252C147.831 132.859 147.455 132.31 147.455 131.706C147.455 131.102 147.831 130.553 148.511 130.161L280.699 53.6599C281.975 52.9226 283.978 52.9226 285.261 53.6599L359.337 96.5266C360.018 96.9188 360.394 97.4679 360.394 98.0719C360.394 98.6758 360.018 99.2249 359.337 99.6171L340.861 110.308L340.47 109.626L358.946 98.9347C359.368 98.6915 359.611 98.3699 359.611 98.064C359.611 97.7581 359.368 97.4444 358.946 97.1934L284.87 54.3266C283.845 53.7383 282.115 53.7383 281.09 54.3266L148.903 130.828C148.48 131.071 148.238 131.393 148.238 131.699C148.238 132.004 148.48 132.318 148.903 132.569L178.819 149.881C179.845 150.469 181.574 150.469 182.599 149.881L209.268 134.444C209.691 134.201 209.933 133.879 209.933 133.573C209.933 133.267 209.691 132.954 209.268 132.703L195.621 124.804C194.94 124.412 194.564 123.863 194.564 123.259C194.564 122.655 194.94 122.105 195.621 121.713L240.429 95.7815C241.713 95.0441 243.716 95.0441 244.992 95.7815L317.08 137.495C317.76 137.887 318.136 138.436 318.136 139.04C318.136 139.644 317.76 140.193 317.08 140.586L241.431 184.362C240.789 184.731 239.968 184.919 239.154 184.919H239.146Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.493 109.908C310.671 109.908 309.85 109.72 309.216 109.351L266.066 84.3843C265.385 83.9921 265.01 83.4431 265.01 82.8391C265.01 82.2351 265.385 81.686 266.066 81.2938L272.178 77.7562C273.453 77.0189 275.465 77.0111 276.74 77.7562L322.558 104.276L313.778 109.359C313.136 109.728 312.315 109.916 311.501 109.916L311.493 109.908ZM274.455 77.9916C273.766 77.9916 273.078 78.1406 272.569 78.4387L266.457 81.9763C266.035 82.2194 265.792 82.541 265.792 82.8469C265.792 83.1528 266.035 83.4666 266.457 83.7176L309.607 108.685C310.632 109.273 312.362 109.273 313.387 108.685L320.993 104.284L276.349 78.4465C275.84 78.1484 275.152 77.9994 274.463 77.9994L274.455 77.9916Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.544 211.777C284.722 211.777 283.901 211.588 283.267 211.22L271.309 204.301C270.629 203.909 270.253 203.36 270.253 202.756C270.253 202.152 270.629 201.603 271.309 201.211L287.297 191.963C288.572 191.226 290.584 191.226 291.859 191.963L297.564 195.265C298.589 195.854 300.318 195.854 301.344 195.265L373.565 153.465C373.987 153.222 374.23 152.9 374.23 152.595C374.23 152.289 373.987 151.975 373.565 151.724L368.666 148.884C367.641 148.296 365.911 148.296 364.886 148.884L300.522 186.135C299.246 186.88 297.243 186.88 295.96 186.135L283.196 178.746C282.171 178.158 280.442 178.15 279.417 178.746L253.483 193.751L253.092 193.069L279.025 178.064C280.301 177.318 282.304 177.326 283.588 178.064L296.351 185.445C297.376 186.033 299.105 186.041 300.131 185.445L364.495 148.194C365.771 147.449 367.774 147.457 369.057 148.194L373.956 151.034C374.637 151.426 375.012 151.975 375.012 152.579C375.012 153.183 374.637 153.732 373.956 154.124L301.735 195.924C300.459 196.661 298.456 196.661 297.173 195.924L291.468 192.622C290.443 192.034 288.713 192.034 287.688 192.622L271.701 201.87C271.278 202.113 271.036 202.435 271.036 202.74C271.036 203.046 271.278 203.36 271.701 203.611L283.658 210.529C284.683 211.118 286.413 211.126 287.438 210.529L389.396 151.528C389.818 151.285 390.061 150.963 390.061 150.657C390.061 150.351 389.818 150.037 389.396 149.786L330.791 115.87L331.182 115.187L389.787 149.104C390.468 149.496 390.843 150.045 390.843 150.649C390.843 151.253 390.468 151.802 389.787 152.195L287.829 211.196C287.187 211.565 286.366 211.753 285.552 211.753L285.544 211.777Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.364 177.499C299.613 177.499 298.893 177.342 298.345 177.028L286.482 170.165C285.887 169.82 285.567 169.326 285.567 168.776C285.567 168.141 286.013 167.514 286.787 167.067L336.933 138.044C338.302 137.252 340.306 137.174 341.503 137.872L353.366 144.735C353.961 145.08 354.282 145.574 354.282 146.123C354.282 146.759 353.836 147.386 353.061 147.833L302.916 176.856C302.172 177.287 301.249 177.507 300.357 177.507L300.364 177.499ZM339.492 138.185C338.733 138.185 337.927 138.366 337.316 138.719L287.171 167.741C286.654 168.039 286.341 168.424 286.341 168.769C286.341 169.114 286.631 169.341 286.866 169.482L298.729 176.346C299.676 176.895 301.413 176.816 302.516 176.173L352.662 147.151C353.178 146.853 353.491 146.469 353.491 146.123C353.491 145.786 353.202 145.551 352.967 145.41L341.104 138.546C340.681 138.303 340.102 138.185 339.492 138.185Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.742 146.186C395.92 146.186 395.098 145.998 394.457 145.629L348.498 119.031C347.817 118.638 347.441 118.089 347.441 117.485C347.441 116.881 347.817 116.332 348.498 115.94L356.37 111.383C357.646 110.638 359.649 110.638 360.933 111.383L393.111 130.004L392.719 130.687L360.541 112.065C359.516 111.477 357.787 111.469 356.762 112.065L348.889 116.623C348.467 116.866 348.224 117.187 348.224 117.493C348.224 117.799 348.467 118.113 348.889 118.364L394.848 144.962C395.873 145.551 397.603 145.551 398.628 144.962L418.543 133.432C418.966 133.189 419.209 132.867 419.209 132.561C419.209 132.255 418.966 131.942 418.543 131.691L369.087 103.068L369.478 102.386L418.935 131.008C419.616 131.4 419.991 131.95 419.991 132.554C419.991 133.157 419.616 133.707 418.935 134.099L399.019 145.629C398.377 145.998 397.556 146.186 396.742 146.186Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.855 165.027C218.104 165.027 217.392 164.87 216.836 164.556L212.705 162.164C212.11 161.819 211.789 161.325 211.789 160.776C211.789 160.14 212.235 159.513 213.01 159.066L216.539 157.019C217.909 156.226 219.912 156.148 221.109 156.846L225.241 159.238C225.836 159.583 226.157 160.078 226.157 160.627C226.157 161.262 225.711 161.89 224.936 162.337L221.406 164.384C220.663 164.815 219.74 165.035 218.848 165.035L218.855 165.027ZM219.106 157.16C218.347 157.16 217.541 157.34 216.93 157.693L213.401 159.74C212.885 160.038 212.572 160.423 212.572 160.768C212.572 161.105 212.861 161.34 213.096 161.482L217.228 163.874C218.175 164.423 219.912 164.337 221.015 163.702L224.545 161.654C225.061 161.356 225.374 160.972 225.374 160.627C225.374 160.289 225.084 160.054 224.85 159.913L220.718 157.521C220.295 157.277 219.716 157.16 219.106 157.16Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.773 157.552C231.022 157.552 230.302 157.395 229.754 157.081L225.623 154.689C225.028 154.344 224.707 153.85 224.707 153.301C224.707 152.665 225.153 152.038 225.928 151.591L229.457 149.543C230.827 148.751 232.83 148.673 234.027 149.371L238.159 151.763C238.754 152.108 239.075 152.602 239.075 153.152C239.075 153.787 238.628 154.414 237.854 154.861L234.324 156.909C233.581 157.34 232.658 157.56 231.766 157.56L231.773 157.552ZM232.024 149.685C231.265 149.685 230.459 149.865 229.848 150.226L226.319 152.273C225.803 152.571 225.49 152.955 225.49 153.301C225.49 153.646 225.779 153.873 226.014 154.014L230.146 156.407C231.093 156.956 232.822 156.877 233.933 156.234L237.463 154.187C237.979 153.889 238.292 153.504 238.292 153.159C238.292 152.814 238.002 152.587 237.768 152.446L233.636 150.053C233.213 149.81 232.634 149.692 232.024 149.692V149.685Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.701 150.069C243.95 150.069 243.23 149.912 242.682 149.598L238.55 147.206C237.956 146.861 237.635 146.367 237.635 145.817C237.635 145.182 238.081 144.555 238.856 144.108L242.385 142.06C243.754 141.268 245.758 141.19 246.955 141.888L251.087 144.28C251.681 144.625 252.002 145.119 252.002 145.668C252.002 146.304 251.556 146.931 250.781 147.378L247.252 149.426C246.509 149.857 245.585 150.077 244.693 150.077L244.701 150.069ZM244.952 142.201C244.192 142.201 243.386 142.382 242.776 142.743L239.247 144.79C238.73 145.088 238.417 145.472 238.417 145.817C238.417 146.163 238.707 146.39 238.942 146.531L243.073 148.924C244.02 149.473 245.758 149.386 246.861 148.751L250.39 146.704C250.907 146.406 251.22 146.021 251.22 145.676C251.22 145.331 250.93 145.104 250.695 144.963L246.564 142.57C246.141 142.327 245.562 142.209 244.952 142.209V142.201Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.846 172.549C231.094 172.549 230.374 172.393 229.827 172.079L225.695 169.686C225.1 169.341 224.779 168.847 224.779 168.298C224.779 167.663 225.225 167.035 226 166.588L229.529 164.541C230.891 163.749 232.902 163.67 234.099 164.368L238.231 166.761C238.826 167.106 239.147 167.6 239.147 168.149C239.147 168.784 238.701 169.412 237.926 169.859L234.397 171.906C233.653 172.338 232.73 172.557 231.838 172.557L231.846 172.549ZM232.096 164.682C231.337 164.682 230.531 164.862 229.921 165.215L226.391 167.263C225.875 167.561 225.562 167.945 225.562 168.29C225.562 168.635 225.851 168.863 226.086 169.004L230.218 171.396C231.165 171.945 232.894 171.859 234.005 171.224L237.535 169.177C238.051 168.878 238.364 168.494 238.364 168.149C238.364 167.804 238.075 167.576 237.84 167.435L233.708 165.043C233.286 164.8 232.706 164.682 232.096 164.682Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.691 157.591C256.94 157.591 256.22 157.434 255.672 157.12L251.541 154.728C250.946 154.383 250.625 153.889 250.625 153.34C250.625 152.704 251.071 152.077 251.846 151.63L255.375 149.583C256.737 148.79 258.748 148.712 259.945 149.41L264.077 151.802C264.672 152.147 264.993 152.642 264.993 153.191C264.993 153.826 264.546 154.454 263.772 154.901L260.242 156.948C259.499 157.379 258.576 157.599 257.684 157.599L257.691 157.591ZM257.942 149.724C257.183 149.724 256.377 149.904 255.766 150.265L252.237 152.312C251.721 152.61 251.408 152.995 251.408 153.34C251.408 153.685 251.697 153.912 251.932 154.054L256.064 156.446C257.011 156.995 258.748 156.909 259.851 156.273L263.381 154.226C263.897 153.928 264.21 153.544 264.21 153.199C264.21 152.853 263.92 152.626 263.686 152.485L259.554 150.092C259.131 149.849 258.552 149.732 257.942 149.732V149.724Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.847 209.463C148.096 209.463 147.376 209.306 146.828 208.992L140.529 205.345C139.934 204.999 139.613 204.505 139.613 203.956C139.613 203.321 140.059 202.693 140.834 202.246L167.801 186.637C169.162 185.845 171.173 185.766 172.371 186.464L178.67 190.112C179.265 190.457 179.586 190.951 179.586 191.5C179.586 192.136 179.14 192.763 178.365 193.21L151.398 208.819C150.655 209.251 149.732 209.47 148.839 209.47L148.847 209.463ZM170.367 186.778C169.608 186.778 168.802 186.959 168.192 187.312L141.225 202.921C140.709 203.219 140.396 203.603 140.396 203.948C140.396 204.294 140.685 204.521 140.92 204.662L147.22 208.31C148.167 208.859 149.904 208.78 151.007 208.137L177.974 192.528C178.49 192.23 178.803 191.845 178.803 191.5C178.803 191.155 178.514 190.928 178.279 190.786L171.979 187.139C171.557 186.896 170.978 186.778 170.367 186.778Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9102 203.525C77.159 203.525 76.439 203.368 75.8913 203.054L71.7594 200.662C71.1647 200.317 70.8438 199.823 70.8438 199.273C70.8438 198.638 71.2899 198.011 72.0646 197.563L85.4618 189.806C86.8312 189.014 88.8346 188.935 90.0319 189.633L94.1637 192.026C94.7584 192.371 95.0793 192.865 95.0793 193.414C95.0793 194.049 94.6332 194.677 93.8585 195.124L80.4613 202.882C79.7179 203.313 78.7945 203.533 77.9024 203.533L77.9102 203.525ZM76.2825 202.372C77.2294 202.921 78.9667 202.842 80.0701 202.199L93.4672 194.442C93.9837 194.144 94.2967 193.759 94.2967 193.414C94.2967 193.069 94.0072 192.841 93.7724 192.7L89.6406 190.308C88.6937 189.759 86.9565 189.837 85.8531 190.48L72.4559 198.238C71.9394 198.536 71.6264 198.92 71.6264 199.266C71.6264 199.603 71.9159 199.838 72.1507 199.979L76.2825 202.372Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.215 260.503C195.393 260.503 194.571 260.314 193.938 259.946L175.462 249.255L175.853 248.572L194.329 259.263C195.354 259.852 197.083 259.852 198.109 259.263L272.176 216.397C272.599 216.153 272.842 215.832 272.842 215.526C272.842 215.22 272.599 214.906 272.176 214.655L139.981 138.154C138.956 137.566 137.227 137.558 136.201 138.154L106.285 155.465C105.862 155.709 105.62 156.03 105.62 156.336C105.62 156.642 105.862 156.956 106.285 157.207L132.954 172.644C133.979 173.232 135.708 173.232 136.734 172.644L150.381 164.745C151.657 164.007 153.66 164.007 154.943 164.745L199.752 190.677C200.433 191.069 200.808 191.618 200.808 192.222C200.808 192.826 200.433 193.375 199.752 193.767L127.672 235.481C126.396 236.226 124.393 236.226 123.109 235.481L47.4607 191.704C46.7799 191.312 46.4043 190.763 46.4043 190.159C46.4043 189.555 46.7799 189.006 47.4607 188.614L85.0777 166.847C86.3611 166.11 88.3644 166.102 89.6399 166.847L133.243 192.081C133.924 192.473 134.3 193.022 134.3 193.626C134.3 194.23 133.924 194.779 133.243 195.171L114.165 206.215L113.774 205.533L132.852 194.489C133.275 194.246 133.517 193.924 133.517 193.618C133.517 193.312 133.275 192.998 132.852 192.747L89.2487 167.514C88.2235 166.925 86.4941 166.917 85.469 167.514L47.852 189.28C47.4294 189.524 47.1868 189.845 47.1868 190.151C47.1868 190.457 47.4294 190.771 47.852 191.022L123.501 234.798C124.526 235.394 126.255 235.394 127.28 234.798L199.361 193.085C199.783 192.841 200.026 192.52 200.026 192.214C200.026 191.908 199.783 191.594 199.361 191.343L154.552 165.411C153.527 164.823 151.798 164.823 150.772 165.411L137.125 173.31C135.849 174.055 133.846 174.055 132.563 173.31L105.893 157.874C105.213 157.481 104.837 156.932 104.837 156.328C104.837 155.724 105.213 155.175 105.893 154.783L135.81 137.472C137.086 136.734 139.089 136.726 140.372 137.472L272.568 213.973C273.249 214.365 273.624 214.914 273.624 215.518C273.624 216.122 273.249 216.671 272.568 217.063L198.5 259.93C197.858 260.299 197.036 260.487 196.223 260.487L196.215 260.503Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.471 238.438L177.082 233.583C176.401 233.19 176.025 232.641 176.025 232.037C176.025 231.433 176.401 230.884 177.082 230.492L220.231 205.525C221.507 204.78 223.51 204.78 224.794 205.525L230.905 209.063C231.586 209.455 231.962 210.004 231.962 210.608C231.962 211.212 231.586 211.761 230.905 212.153L185.479 238.446L185.471 238.438ZM222.509 205.752C221.82 205.752 221.131 205.902 220.623 206.2L177.473 231.167C177.051 231.41 176.808 231.731 176.808 232.037C176.808 232.343 177.051 232.657 177.473 232.908L185.471 237.536L185.674 237.418L230.506 211.471C230.929 211.228 231.171 210.906 231.171 210.6C231.171 210.294 230.929 209.98 230.506 209.729L224.395 206.192C223.886 205.894 223.197 205.745 222.509 205.745V205.752Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.299 278.12C104.478 278.12 103.656 277.932 103.022 277.563L1.05644 218.562C0.375622 218.169 0 217.62 0 217.016C0 216.412 0.375622 215.863 1.05644 215.471L13.0137 208.553C14.2893 207.815 16.2926 207.815 17.576 208.553L33.5634 217.808C34.2442 218.201 34.6198 218.75 34.6198 219.354C34.6198 219.958 34.2442 220.507 33.5634 220.899L27.8586 224.201C27.436 224.444 27.1935 224.766 27.1935 225.072C27.1935 225.378 27.436 225.692 27.8586 225.943L100.088 267.743C101.113 268.339 102.842 268.339 103.867 267.743L108.766 264.903C109.189 264.66 109.431 264.338 109.431 264.032C109.431 263.726 109.189 263.413 108.766 263.162L44.4016 225.911C43.7208 225.519 43.3452 224.97 43.3452 224.366C43.3452 223.762 43.7208 223.213 44.4016 222.821L57.1649 215.432C57.5875 215.189 57.8301 214.867 57.8301 214.561C57.8301 214.255 57.5875 213.941 57.1649 213.69L31.2314 198.685L31.6227 198.003L57.5562 213.008C58.237 213.4 58.6127 213.949 58.6127 214.553C58.6127 215.157 58.237 215.706 57.5562 216.099L44.7929 223.487C44.3703 223.731 44.1277 224.052 44.1277 224.358C44.1277 224.664 44.3703 224.978 44.7929 225.229L109.157 262.479C109.838 262.872 110.214 263.421 110.214 264.025C110.214 264.629 109.838 265.178 109.157 265.57L104.259 268.409C102.983 269.147 100.98 269.154 99.6963 268.409L27.4673 226.609C26.7865 226.217 26.4109 225.668 26.4109 225.064C26.4109 224.46 26.7865 223.911 27.4673 223.519L33.1721 220.217C33.5947 219.973 33.8373 219.652 33.8373 219.346C33.8373 219.04 33.5947 218.726 33.1721 218.475L17.1847 209.219C16.1596 208.631 14.4301 208.631 13.405 209.219L1.44771 216.138C1.02513 216.381 0.782545 216.703 0.782545 217.008C0.782545 217.314 1.02513 217.628 1.44771 217.879L103.406 276.881C104.431 277.469 106.16 277.469 107.185 276.881L165.782 242.972L166.174 243.654L107.577 277.563C106.935 277.932 106.113 278.12 105.299 278.12Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.913 256.965C112.162 256.965 111.442 256.808 110.894 256.494L60.146 227.127C59.5513 226.782 59.2305 226.288 59.2305 225.739C59.2305 225.103 59.6765 224.476 60.4512 224.029L71.7199 217.51C73.0815 216.718 75.0927 216.64 76.29 217.338L127.038 246.705C127.633 247.05 127.954 247.545 127.954 248.094C127.954 248.729 127.508 249.357 126.733 249.804L115.464 256.322C114.721 256.753 113.797 256.973 112.905 256.973L112.913 256.965ZM111.285 255.812C112.232 256.361 113.97 256.283 115.073 255.639L126.342 249.121C126.858 248.823 127.171 248.439 127.171 248.094C127.171 247.749 126.882 247.521 126.647 247.38L75.8987 218.012C74.9518 217.463 73.2146 217.542 72.1112 218.185L60.8425 224.703C60.326 225.001 60.013 225.386 60.013 225.731C60.013 226.076 60.3026 226.303 60.5373 226.445L111.285 255.812Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8398 182.817C87.0886 182.817 86.3765 182.66 85.8209 182.346L81.689 179.954C81.0943 179.609 80.7734 179.115 80.7734 178.566C80.7734 177.93 81.2195 177.303 81.9942 176.856L85.5235 174.808C86.8929 174.016 88.8963 173.938 90.0936 174.636L94.2254 177.028C94.8201 177.373 95.141 177.868 95.141 178.417C95.141 179.052 94.6949 179.679 93.9202 180.127L90.3909 182.174C89.6475 182.605 88.7241 182.825 87.832 182.825L87.8398 182.817ZM86.2121 181.664C87.159 182.213 88.8963 182.127 89.9997 181.491L93.5289 179.444C94.0454 179.146 94.3584 178.762 94.3584 178.417C94.3584 178.071 94.0689 177.844 93.8341 177.703L89.7023 175.31C88.7554 174.761 87.0182 174.84 85.9148 175.483L82.3855 177.53C81.869 177.828 81.556 178.213 81.556 178.558C81.556 178.895 81.8455 179.13 82.0803 179.272L86.2121 181.664Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.76 190.3C100.008 190.3 99.2886 190.143 98.7408 189.829L94.6089 187.437C94.0142 187.092 93.6934 186.598 93.6934 186.049C93.6934 185.413 94.1394 184.786 94.9141 184.339L98.4434 182.291C99.805 181.499 101.816 181.421 103.013 182.119L107.145 184.511C107.74 184.856 108.061 185.351 108.061 185.9C108.061 186.535 107.615 187.163 106.84 187.61L103.311 189.649C102.567 190.08 101.644 190.3 100.752 190.3H100.76ZM101.01 182.433C100.251 182.433 99.4451 182.613 98.8347 182.974L95.3054 185.021C94.7889 185.319 94.4759 185.704 94.4759 186.049C94.4759 186.394 94.7654 186.621 95.0002 186.762L99.132 189.155C100.079 189.704 101.808 189.625 102.92 188.982L106.449 186.935C106.965 186.637 107.278 186.253 107.278 185.907C107.278 185.562 106.989 185.335 106.754 185.194L102.622 182.801C102.2 182.558 101.621 182.441 101.01 182.441V182.433Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.687 197.775C112.936 197.775 112.216 197.618 111.669 197.305L107.537 194.912C106.942 194.567 106.621 194.073 106.621 193.524C106.621 192.889 107.067 192.261 107.842 191.814L111.371 189.767C112.741 188.974 114.744 188.896 115.941 189.594L120.073 191.986C120.668 192.332 120.989 192.826 120.989 193.375C120.989 194.01 120.543 194.638 119.768 195.085L116.239 197.132C115.495 197.563 114.572 197.783 113.68 197.783L113.687 197.775ZM112.06 196.622C113.007 197.171 114.744 197.085 115.847 196.45L119.377 194.402C119.893 194.104 120.206 193.72 120.206 193.375C120.206 193.03 119.917 192.802 119.682 192.661L115.55 190.269C114.603 189.72 112.866 189.798 111.762 190.441L108.233 192.488C107.717 192.787 107.404 193.171 107.404 193.516C107.404 193.861 107.693 194.089 107.928 194.23L112.06 196.622Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8496 190.331C74.0983 190.331 73.3784 190.175 72.8306 189.861L68.6988 187.468C68.104 187.123 67.7832 186.629 67.7832 186.08C67.7832 185.445 68.2293 184.817 69.004 184.37L72.5333 182.323C73.9027 181.531 75.906 181.452 77.1033 182.15L81.2352 184.543C81.8299 184.888 82.1507 185.382 82.1507 185.931C82.1507 186.566 81.7047 187.194 80.93 187.641L77.4007 189.688C76.6573 190.12 75.7339 190.339 74.8418 190.339L74.8496 190.331ZM75.1 182.464C74.3409 182.464 73.5349 182.644 72.9245 182.997L69.3952 185.045C68.8788 185.343 68.5657 185.727 68.5657 186.072C68.5657 186.417 68.8553 186.645 69.0901 186.786L73.2219 189.178C74.1688 189.727 75.906 189.649 77.0094 189.006L80.5387 186.959C81.0552 186.661 81.3682 186.276 81.3682 185.931C81.3682 185.586 81.0786 185.358 80.8439 185.217L76.712 182.825C76.2895 182.582 75.7104 182.464 75.1 182.464Z",
    fill: "#2C75E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.697 205.29C99.946 205.29 99.2261 205.133 98.6783 204.819L94.5464 202.427C93.9517 202.082 93.6309 201.587 93.6309 201.038C93.6309 200.403 94.0769 199.775 94.8516 199.328L98.3809 197.281C99.7504 196.489 101.754 196.41 102.951 197.109L107.083 199.501C107.678 199.846 107.998 200.34 107.998 200.889C107.998 201.525 107.552 202.152 106.778 202.599L103.248 204.646C102.505 205.078 101.582 205.298 100.689 205.298L100.697 205.29ZM100.948 197.422C100.189 197.422 99.3826 197.603 98.7722 197.964L95.2429 200.003C94.7264 200.301 94.4134 200.685 94.4134 201.03C94.4134 201.376 94.7029 201.603 94.9377 201.744L99.0695 204.137C100.016 204.686 101.746 204.599 102.857 203.964L106.386 201.917C106.903 201.619 107.216 201.234 107.216 200.889C107.216 200.544 106.926 200.317 106.692 200.175L102.56 197.783C102.137 197.54 101.558 197.422 100.948 197.422Z",
    fill: "#2C75E4"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M175.784 276.073C215.761 276.073 248.169 257.316 248.169 234.179C248.169 211.041 215.761 192.285 175.784 192.285C135.807 192.285 103.398 211.041 103.398 234.179C103.398 257.316 135.807 276.073 175.784 276.073Z",
    fill: "url(#paint0_radial_1_392)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M230.585 239.865C270.562 239.865 302.97 221.109 302.97 197.971C302.97 174.834 270.562 156.077 230.585 156.077C190.607 156.077 158.199 174.834 158.199 197.971C158.199 221.109 190.607 239.865 230.585 239.865Z",
    fill: "url(#paint1_radial_1_392)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M290.684 202.16C330.662 202.16 363.07 183.403 363.07 160.266C363.07 137.128 330.662 118.372 290.684 118.372C250.707 118.372 218.299 137.128 218.299 160.266C218.299 183.403 250.707 202.16 290.684 202.16Z",
    fill: "url(#paint2_radial_1_392)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.1246 223.495C91.1979 223.495 88.2633 222.836 85.9861 221.511L49.8403 200.591C47.3205 199.132 45.9354 197.085 45.9354 194.826C45.9354 192.567 47.3205 190.52 49.8403 189.061L85.9861 168.141C87.3086 167.372 88.0677 166.431 88.0677 165.545C88.0677 164.658 87.3086 163.709 85.9861 162.949L75.14 156.673C72.6202 155.214 71.2351 153.167 71.2351 150.908C71.2351 148.649 72.6202 146.602 75.14 145.143L111.286 124.223C115.848 121.58 123.001 121.58 127.571 124.223L163.716 145.143C166.236 146.602 167.621 148.649 167.621 150.908C167.621 153.167 166.236 155.214 163.716 156.673L127.571 177.593C126.248 178.362 125.489 179.303 125.489 180.189C125.489 181.076 126.248 182.025 127.571 182.786L138.417 189.061C140.936 190.52 142.322 192.567 142.322 194.826C142.322 197.085 140.936 199.132 138.417 200.591L102.271 221.511C99.9858 222.829 97.0591 223.495 94.1324 223.495H94.1246ZM119.424 125.902C117.124 125.902 114.823 126.396 113.109 127.384L76.9634 148.304C75.6408 149.073 74.8818 150.014 74.8818 150.9C74.8818 151.787 75.6408 152.736 76.9634 153.497L87.8094 159.772C90.3292 161.231 91.7143 163.278 91.7143 165.537C91.7143 167.796 90.3292 169.851 87.8094 171.302L51.6637 192.222C50.3412 192.991 49.5821 193.932 49.5821 194.818C49.5821 195.704 50.3412 196.654 51.6637 197.414L87.8094 218.334C91.237 220.319 97.02 220.319 100.44 218.334L136.585 197.414C137.908 196.646 138.667 195.704 138.667 194.818C138.667 193.932 137.908 192.983 136.585 192.222L125.739 185.947C123.22 184.488 121.835 182.441 121.835 180.181C121.835 177.922 123.22 175.875 125.739 174.416L161.885 153.497C163.208 152.728 163.967 151.787 163.967 150.9C163.967 150.014 163.208 149.065 161.885 148.304L125.739 127.384C124.026 126.396 121.725 125.902 119.424 125.902Z",
    fill: "#6EE8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1242 222.021C91.4401 222.021 88.756 221.432 86.7135 220.248L50.5678 199.328C48.5175 198.144 47.3906 196.544 47.3906 194.826C47.3906 193.108 48.5175 191.516 50.5678 190.324L86.7135 169.404C88.529 168.353 89.5229 166.98 89.5229 165.537C89.5229 164.094 88.5212 162.721 86.7135 161.67L75.8675 155.395C73.8172 154.21 72.6903 152.61 72.6903 150.892C72.6903 149.175 73.8172 147.582 75.8675 146.39L112.013 125.471C116.098 123.11 122.75 123.11 126.835 125.471L162.98 146.39C165.031 147.575 166.158 149.175 166.158 150.892C166.158 152.61 165.031 154.203 162.98 155.395L126.835 176.314C125.019 177.366 124.025 178.738 124.025 180.181C124.025 181.625 125.027 182.997 126.835 184.049L137.681 190.324C139.731 191.508 140.858 193.108 140.858 194.826C140.858 196.544 139.731 198.136 137.681 199.328L101.535 220.248C99.4925 221.432 96.8084 222.021 94.1242 222.021ZM119.424 124.435C116.873 124.435 114.322 125 112.381 126.122L76.2352 147.041C74.4197 148.092 73.4259 149.465 73.4259 150.908C73.4259 152.351 74.4276 153.724 76.2352 154.775L87.0813 161.05C89.1316 162.235 90.2585 163.835 90.2585 165.553C90.2585 167.27 89.1316 168.871 87.0813 170.055L50.9356 190.975C49.12 192.026 48.1262 193.398 48.1262 194.842C48.1262 196.285 49.1279 197.658 50.9356 198.709L87.0813 219.628C90.9706 221.879 97.2857 221.879 101.175 219.628L137.321 198.709C139.136 197.658 140.13 196.285 140.13 194.842C140.13 193.398 139.128 192.026 137.321 190.975L126.475 184.7C124.424 183.515 123.298 181.915 123.298 180.197C123.298 178.479 124.424 176.887 126.475 175.695L162.62 154.775C164.436 153.724 165.43 152.351 165.43 150.908C165.43 149.465 164.428 148.092 162.62 147.041L126.475 126.122C124.534 125 121.983 124.435 119.432 124.435H119.424Z",
    fill: "#6EE8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.082 171.122C135.536 171.906 135.27 172.91 134.495 173.357C133.72 173.804 132.727 173.538 132.273 172.745C131.819 171.961 132.085 170.957 132.86 170.51C133.634 170.063 134.628 170.33 135.082 171.122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.512 166.243C143.966 167.027 143.7 168.031 142.925 168.478C142.15 168.926 141.156 168.659 140.702 167.867C140.249 167.074 140.515 166.078 141.289 165.631C142.064 165.184 143.058 165.451 143.512 166.243Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.947 161.364C152.401 162.148 152.135 163.152 151.36 163.6C150.586 164.047 149.592 163.78 149.138 162.988C148.684 162.203 148.95 161.199 149.725 160.752C150.5 160.305 151.493 160.572 151.947 161.364Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.383 156.485C160.837 157.27 160.57 158.274 159.796 158.721C159.021 159.168 158.027 158.901 157.573 158.109C157.119 157.324 157.386 156.32 158.16 155.873C158.935 155.426 159.929 155.693 160.383 156.485Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.43 149.379C165.837 149.19 166.299 149.19 166.714 149.465C166.902 149.606 167.082 149.81 167.222 150.069C167.34 150.328 167.418 150.649 167.418 150.979C167.402 151.653 167.074 152.202 166.675 152.469C166.252 152.728 165.798 152.728 165.399 152.524C164.992 152.32 164.687 151.991 164.491 151.7C164.272 151.402 164.139 151.159 164.147 150.932C164.147 150.814 164.17 150.704 164.249 150.579C164.296 150.453 164.39 150.32 164.507 150.179C164.718 149.896 165.023 149.575 165.43 149.379Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.652 143.747C158.106 142.962 159.099 142.688 159.874 143.135C160.649 143.582 160.915 144.586 160.461 145.37C160.007 146.155 159.013 146.429 158.239 145.982C157.464 145.535 157.198 144.531 157.652 143.747Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.216 138.868C149.67 138.083 150.664 137.809 151.438 138.256C152.213 138.703 152.479 139.707 152.025 140.492C151.572 141.276 150.578 141.55 149.803 141.103C149.028 140.656 148.762 139.652 149.216 138.868Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.788 133.989C141.242 133.205 142.236 132.93 143.011 133.377C143.785 133.824 144.052 134.828 143.598 135.613C143.144 136.397 142.15 136.672 141.375 136.224C140.601 135.777 140.334 134.773 140.788 133.989Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.353 129.102C132.807 128.318 133.8 128.043 134.575 128.49C135.35 128.937 135.616 129.942 135.162 130.726C134.708 131.51 133.714 131.785 132.94 131.338C132.165 130.891 131.899 129.887 132.353 129.102Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.736 124.631C123.853 124.192 124.143 123.847 124.534 123.643C124.918 123.47 125.419 123.415 125.888 123.619C126.365 123.808 126.71 124.176 126.858 124.6C127.015 125.016 126.96 125.455 126.733 125.847C126.506 126.239 126.139 126.506 125.771 126.647C125.403 126.78 125.019 126.804 124.659 126.655C124.307 126.498 124.018 126.231 123.853 125.855C123.681 125.502 123.619 125.055 123.736 124.623V124.631Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.135 124.929C113.814 124.074 114.346 123.102 115.332 122.874C116.318 122.655 117.194 123.306 117.288 124.2C117.382 125.11 116.819 125.902 116.052 126.074C115.293 126.247 114.448 125.769 114.135 124.921V124.929Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.612 129.612C105.158 128.828 105.425 127.824 106.199 127.377C106.974 126.929 107.968 127.196 108.422 127.988C108.876 128.781 108.61 129.777 107.835 130.224C107.06 130.671 106.066 130.404 105.612 129.612Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.177 134.491C96.7231 133.707 96.9892 132.703 97.7639 132.255C98.5386 131.808 99.5324 132.075 99.9863 132.867C100.44 133.652 100.174 134.656 99.3994 135.103C98.6247 135.55 97.6309 135.283 97.177 134.491Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7414 139.378C88.2876 138.593 88.5536 137.589 89.3284 137.142C90.1031 136.695 91.0969 136.962 91.5508 137.754C92.0047 138.538 91.7386 139.542 90.9639 139.99C90.1891 140.437 89.1953 140.17 88.7414 139.378Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3118 144.257C79.8579 143.472 80.1239 142.468 80.8987 142.021C81.6734 141.574 82.6672 141.841 83.1211 142.633C83.575 143.417 83.3089 144.421 82.5342 144.868C81.7595 145.315 80.7656 145.049 80.3118 144.257Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.097 150.343C72.6509 150.273 72.291 150.014 72.1031 149.543C71.931 149.096 71.9858 148.461 72.3223 147.959C72.6509 147.449 73.1439 147.159 73.6056 147.135C74.0673 147.104 74.4743 147.276 74.7716 147.622C75.3429 148.335 75.3742 149.261 75.0846 149.724C74.9203 149.967 74.6777 150.1 74.3256 150.21C73.9969 150.312 73.543 150.406 73.1048 150.336L73.097 150.343Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.334 156.995C78.8801 157.779 77.8863 158.054 77.1116 157.607C76.3368 157.16 76.0708 156.156 76.5246 155.371C76.9785 154.587 77.9724 154.312 78.7471 154.76C79.5218 155.207 79.7879 156.211 79.334 156.995Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7382 161.929C87.4643 162.29 87.0965 162.509 86.7131 162.627C86.5253 162.682 86.3375 162.705 86.1575 162.69C85.954 162.666 85.7427 162.596 85.5471 162.486C84.7724 162.039 84.5063 161.035 84.9602 160.25C85.4141 159.466 86.4079 159.191 87.1826 159.638C87.3783 159.748 87.5348 159.897 87.6678 160.07C87.8165 160.266 87.926 160.478 87.9808 160.689C88.0982 161.113 88.0043 161.568 87.7304 161.929H87.7382Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.893 169.733C86.4548 168.926 86.6347 167.992 87.1356 167.561C87.3782 167.325 87.7147 167.255 88.0825 167.247C88.4737 167.255 88.8807 167.325 89.2719 167.561C89.6554 167.788 89.9214 168.204 89.9214 168.659C89.9449 169.137 89.718 169.639 89.3032 170.024C88.4346 170.761 87.3234 170.51 86.9008 169.733H86.893Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.458 174.612C78.0042 173.828 78.2702 172.824 79.0449 172.377C79.8197 171.93 80.8135 172.196 81.2674 172.989C81.7212 173.773 81.4552 174.777 80.6805 175.224C79.9057 175.671 78.9119 175.405 78.458 174.612Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0227 179.491C69.5688 178.707 69.8349 177.703 70.6096 177.256C71.3843 176.809 72.3782 177.075 72.832 177.868C73.2859 178.66 73.0198 179.656 72.2451 180.103C71.4704 180.55 70.4766 180.283 70.0227 179.491Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.595 184.37C61.1411 183.586 61.4071 182.582 62.1819 182.135C62.9566 181.687 63.9504 181.954 64.4043 182.746C64.8582 183.539 64.5921 184.535 63.8174 184.982C63.0427 185.429 62.0488 185.162 61.595 184.37Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1575 189.249C52.7036 188.465 52.9696 187.461 53.7444 187.013C54.5191 186.566 55.5129 186.833 55.9668 187.625C56.4207 188.41 56.1546 189.414 55.3799 189.861C54.6052 190.308 53.6113 190.041 53.1575 189.249Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1109 196.356C47.704 196.544 47.2423 196.544 46.8275 196.269C46.6397 196.128 46.4597 195.924 46.3189 195.665C46.2015 195.406 46.1232 195.085 46.1232 194.755C46.1389 194.081 46.4676 193.532 46.8666 193.265C47.2892 193.006 47.7431 193.006 48.1422 193.21C48.5413 193.414 48.8543 193.744 49.05 194.034C49.2691 194.332 49.4021 194.575 49.3943 194.802C49.3943 194.92 49.3708 195.03 49.2925 195.155C49.2456 195.281 49.1517 195.414 49.0343 195.555C48.823 195.838 48.5178 196.159 48.1109 196.356Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8887 201.987C55.4348 202.772 54.441 203.046 53.6662 202.599C52.8915 202.152 52.6255 201.148 53.0793 200.364C53.5332 199.579 54.527 199.305 55.3018 199.752C56.0765 200.199 56.3425 201.203 55.8887 201.987Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3262 206.866C63.8723 207.651 62.8785 207.925 62.1037 207.478C61.329 207.031 61.063 206.027 61.5168 205.243C61.9707 204.458 62.9645 204.184 63.7393 204.631C64.514 205.078 64.78 206.082 64.3262 206.866Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7539 211.745C72.3 212.53 71.3062 212.804 70.5315 212.357C69.7568 211.91 69.4907 210.906 69.9446 210.122C70.3984 209.337 71.3923 209.063 72.167 209.51C72.9417 209.957 73.2078 210.961 72.7539 211.745Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1895 216.632C80.7356 217.416 79.7417 217.691 78.967 217.244C78.1923 216.797 77.9262 215.793 78.3801 215.008C78.834 214.224 79.8278 213.949 80.6025 214.396C81.3773 214.844 81.6433 215.848 81.1895 216.632Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8053 221.103C89.688 221.542 89.3984 221.887 89.0071 222.091C88.6237 222.264 88.1229 222.319 87.6533 222.115C87.1838 221.927 86.8317 221.558 86.683 221.134C86.5265 220.719 86.5813 220.279 86.8082 219.887C87.0351 219.495 87.4029 219.228 87.7707 219.087C88.1385 218.954 88.522 218.93 88.8819 219.079C89.2341 219.236 89.5236 219.503 89.688 219.879C89.8601 220.232 89.9227 220.679 89.8053 221.111V221.103Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3984 220.805C99.7193 221.66 99.1872 222.632 98.2012 222.852C97.2151 223.072 96.3387 222.421 96.2448 221.527C96.1509 220.617 96.7143 219.824 97.4812 219.652C98.2403 219.479 99.0854 219.958 99.3984 220.805Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M107.928 216.122C108.382 216.906 108.116 217.91 107.341 218.358C106.566 218.805 105.572 218.538 105.118 217.746C104.665 216.961 104.931 215.957 105.705 215.51C106.48 215.063 107.474 215.33 107.928 216.122Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.365 211.243C116.819 212.028 116.553 213.032 115.778 213.479C115.004 213.926 114.01 213.659 113.556 212.867C113.102 212.082 113.368 211.078 114.143 210.631C114.918 210.184 115.911 210.451 116.365 211.243Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M124.801 206.364C125.255 207.149 124.989 208.153 124.214 208.6C123.439 209.047 122.445 208.78 121.991 207.988C121.538 207.204 121.804 206.2 122.578 205.752C123.353 205.305 124.347 205.572 124.801 206.364Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M133.228 201.478C133.682 202.262 133.416 203.266 132.641 203.713C131.867 204.16 130.873 203.893 130.419 203.101C129.965 202.317 130.231 201.313 131.006 200.866C131.781 200.419 132.774 200.685 133.228 201.478Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M140.443 195.391C140.889 195.461 141.249 195.72 141.437 196.191C141.609 196.638 141.554 197.273 141.217 197.775C140.889 198.285 140.396 198.575 139.934 198.599C139.472 198.63 139.065 198.458 138.768 198.113C138.197 197.399 138.165 196.473 138.455 196.01C138.619 195.767 138.862 195.634 139.214 195.524C139.543 195.422 139.997 195.328 140.435 195.399L140.443 195.391Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.198 188.739C134.652 187.955 135.646 187.68 136.421 188.127C137.196 188.574 137.462 189.578 137.008 190.363C136.554 191.147 135.56 191.422 134.785 190.975C134.011 190.528 133.745 189.524 134.198 188.739Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M125.802 183.805C126.076 183.445 126.444 183.225 126.827 183.107C127.015 183.052 127.203 183.029 127.383 183.044C127.586 183.068 127.798 183.139 127.993 183.248C128.768 183.696 129.034 184.7 128.58 185.484C128.126 186.268 127.132 186.543 126.358 186.096C126.162 185.978 126.005 185.837 125.872 185.664C125.724 185.468 125.614 185.256 125.559 185.045C125.442 184.621 125.536 184.166 125.81 183.805H125.802Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 176.009C127.086 176.816 126.906 177.75 126.405 178.181C126.162 178.417 125.826 178.487 125.458 178.495C125.067 178.487 124.66 178.417 124.269 178.181C123.885 177.954 123.619 177.538 123.619 177.083C123.596 176.605 123.822 176.103 124.237 175.718C125.106 174.981 126.217 175.232 126.64 176.009H126.647Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.843 259.224C152.535 259.224 150.32 258.746 148.622 257.757L108.65 234.626C106.701 233.496 105.629 231.849 105.629 229.974C105.629 227.864 107.053 225.833 109.526 224.397L147.065 202.67C151.236 200.254 157.394 200.034 161.08 202.16L201.053 225.292C203.001 226.421 204.073 228.068 204.073 229.935C204.073 232.045 202.657 234.077 200.176 235.512L162.637 257.24C160.384 258.542 157.551 259.208 154.843 259.208V259.224ZM154.89 204.364C152.809 204.364 150.586 204.874 148.896 205.854L111.357 227.582C109.831 228.468 109.283 229.402 109.283 229.982C109.283 230.665 110.035 231.206 110.481 231.465L150.453 254.596C153.028 256.087 157.77 255.851 160.814 254.094L198.353 232.367C199.879 231.48 200.426 230.547 200.426 229.959C200.426 229.276 199.675 228.743 199.229 228.484L159.257 205.352C158.114 204.694 156.549 204.372 154.89 204.372V204.364Z",
    fill: "#6EE8FC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154.827 257.757C152.777 257.757 150.82 257.342 149.357 256.494L109.392 233.363C107.913 232.508 107.1 231.308 107.1 229.982C107.1 228.413 108.25 226.845 110.269 225.676L147.808 203.948C151.509 201.807 157.136 201.58 160.36 203.439L200.332 226.57C201.811 227.425 202.625 228.625 202.625 229.951C202.625 231.52 201.475 233.088 199.463 234.257L161.925 255.985C159.906 257.153 157.308 257.75 154.851 257.75L154.827 257.757ZM154.874 202.905C152.542 202.905 150.085 203.478 148.16 204.584L110.621 226.311C108.845 227.339 107.82 228.68 107.82 229.982C107.82 231.033 108.5 232.014 109.745 232.728L149.717 255.859C152.738 257.608 158.035 257.381 161.541 255.349L199.08 233.622C200.856 232.594 201.882 231.253 201.882 229.951C201.882 228.9 201.201 227.927 199.956 227.205L159.984 204.074C158.622 203.282 156.791 202.897 154.874 202.897V202.905Z",
    fill: "#6EE8FC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.155 251.333C141.609 250.549 142.603 250.274 143.37 250.721C144.145 251.168 144.403 252.165 143.949 252.949C143.495 253.733 142.501 254.008 141.734 253.561C140.96 253.114 140.702 252.118 141.155 251.333Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M132.775 246.486C133.228 245.701 134.222 245.427 134.989 245.874C135.764 246.321 136.022 247.317 135.568 248.102C135.114 248.886 134.121 249.16 133.354 248.713C132.579 248.266 132.321 247.27 132.775 246.486Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.401 241.638C124.855 240.854 125.849 240.579 126.616 241.026C127.391 241.473 127.649 242.47 127.195 243.254C126.741 244.038 125.747 244.313 124.981 243.866C124.206 243.419 123.948 242.423 124.401 241.638Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M116.021 236.783C116.475 235.998 117.468 235.724 118.235 236.171C119.01 236.618 119.268 237.614 118.814 238.399C118.36 239.183 117.367 239.458 116.6 239.01C115.825 238.563 115.567 237.567 116.021 236.783Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.937 231.567C108.321 231.323 108.759 231.237 109.103 231.206C109.291 231.182 109.455 231.19 109.596 231.222C109.761 231.245 109.894 231.3 110.011 231.394C110.152 231.48 110.246 231.598 110.332 231.755C110.457 231.92 110.551 232.116 110.598 232.32C110.7 232.72 110.653 233.167 110.426 233.559C110.199 233.951 109.839 234.218 109.44 234.328C109.236 234.383 109.025 234.398 108.822 234.375C108.587 234.328 108.329 234.21 108.094 234.053C107.859 233.881 107.671 233.653 107.538 233.433C107.413 233.19 107.343 232.931 107.327 232.696C107.311 232.202 107.554 231.802 107.937 231.567Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M112.874 224.593C113.328 225.378 113.07 226.374 112.295 226.821C111.912 227.041 111.466 227.088 111.067 226.978C110.691 226.86 110.331 226.601 110.088 226.225C109.838 225.848 109.783 225.394 109.908 224.97C110.01 224.57 110.268 224.201 110.66 223.982C111.434 223.535 112.42 223.809 112.874 224.593Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.248 219.746C121.702 220.53 121.444 221.526 120.669 221.974C119.894 222.421 118.908 222.146 118.454 221.362C118 220.577 118.259 219.581 119.033 219.134C119.808 218.687 120.794 218.962 121.248 219.746Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M129.629 214.891C130.083 215.675 129.824 216.671 129.05 217.118C128.275 217.565 127.289 217.291 126.835 216.506C126.381 215.722 126.639 214.726 127.414 214.279C128.189 213.832 129.175 214.106 129.629 214.891Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M138.01 210.043C138.464 210.827 138.205 211.824 137.431 212.271C136.656 212.718 135.67 212.443 135.216 211.659C134.762 210.875 135.02 209.878 135.795 209.431C136.57 208.984 137.556 209.259 138.01 210.043Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.385 205.196C146.838 205.98 146.58 206.976 145.806 207.423C145.031 207.87 144.045 207.596 143.591 206.811C143.137 206.027 143.395 205.031 144.17 204.584C144.945 204.137 145.931 204.411 146.385 205.196Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M155.525 202.568C155.462 203.47 154.797 204.168 154.014 204.223C153.24 204.27 152.481 203.666 152.308 202.772C152.136 201.878 152.801 201.007 153.803 200.944C154.805 200.874 155.579 201.658 155.517 202.568H155.525Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M164.359 206.192C163.905 206.976 162.912 207.251 162.145 206.804C161.37 206.356 161.112 205.36 161.566 204.576C162.019 203.792 163.013 203.517 163.78 203.964C164.555 204.411 164.813 205.407 164.359 206.192Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.732 211.039C172.278 211.824 171.284 212.098 170.517 211.651C169.743 211.204 169.484 210.208 169.938 209.423C170.392 208.639 171.386 208.364 172.153 208.812C172.928 209.259 173.186 210.255 172.732 211.039Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M181.113 215.887C180.659 216.671 179.665 216.946 178.899 216.499C178.124 216.051 177.866 215.055 178.319 214.271C178.773 213.487 179.767 213.212 180.534 213.659C181.309 214.106 181.567 215.102 181.113 215.887Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M189.494 220.742C189.04 221.527 188.046 221.801 187.28 221.354C186.505 220.907 186.247 219.911 186.7 219.126C187.154 218.342 188.148 218.067 188.915 218.514C189.69 218.962 189.948 219.958 189.494 220.742Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.867 225.59C197.413 226.374 196.419 226.649 195.652 226.201C194.878 225.754 194.619 224.758 195.073 223.974C195.527 223.189 196.521 222.915 197.288 223.362C198.063 223.809 198.321 224.805 197.867 225.59Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M200.881 232.735C200.278 232.069 200.176 231.135 200.388 230.704C200.513 230.469 200.724 230.351 201.061 230.21C201.374 230.084 201.781 229.919 202.235 229.904C202.681 229.888 203.103 230.092 203.354 230.539C203.588 230.971 203.604 231.653 203.307 232.202C203.166 232.484 202.97 232.712 202.751 232.861C202.54 233.026 202.305 233.12 202.078 233.151C201.616 233.222 201.202 233.065 200.881 232.735Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M192.64 237.779C192.186 236.995 192.444 235.998 193.219 235.551C193.994 235.104 194.98 235.379 195.434 236.163C195.888 236.948 195.629 237.944 194.855 238.391C194.08 238.838 193.094 238.563 192.64 237.779Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M184.259 242.627C183.805 241.842 184.063 240.846 184.838 240.399C185.613 239.952 186.599 240.226 187.053 241.011C187.506 241.795 187.248 242.791 186.474 243.238C185.699 243.685 184.713 243.411 184.259 242.627Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M175.886 247.482C175.432 246.697 175.69 245.701 176.465 245.254C177.24 244.807 178.226 245.082 178.679 245.866C179.133 246.65 178.875 247.647 178.1 248.094C177.326 248.541 176.34 248.266 175.886 247.482Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M167.505 252.329C167.051 251.545 167.309 250.549 168.084 250.102C168.859 249.655 169.845 249.929 170.299 250.714C170.753 251.498 170.494 252.494 169.72 252.941C168.945 253.388 167.959 253.114 167.505 252.329Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M216.914 223.307C214.605 223.307 212.39 222.829 210.692 221.84L170.72 198.709C168.771 197.579 167.699 195.932 167.699 194.057C167.699 191.947 169.116 189.916 171.596 188.48L209.135 166.753C213.306 164.337 219.465 164.109 223.15 166.243L263.123 189.374C265.071 190.504 266.143 192.151 266.143 194.018C266.143 196.128 264.727 198.16 262.246 199.595L224.708 221.323C222.454 222.625 219.621 223.291 216.914 223.291V223.307ZM216.96 168.447C214.879 168.447 212.656 168.957 210.966 169.937L173.427 191.665C171.901 192.551 171.354 193.485 171.354 194.065C171.354 194.748 172.105 195.289 172.551 195.548L212.523 218.679C215.098 220.17 219.84 219.934 222.884 218.177L260.423 196.45C261.949 195.563 262.497 194.63 262.497 194.042C262.497 193.359 261.746 192.826 261.299 192.567L221.327 169.435C220.185 168.776 218.619 168.455 216.96 168.455V168.447Z",
    fill: "#6EE8FC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 221.832C214.847 221.832 212.891 221.417 211.427 220.57L171.455 197.438C169.976 196.583 169.162 195.383 169.162 194.057C169.162 192.488 170.312 190.92 172.331 189.751L209.87 168.023C213.572 165.882 219.198 165.655 222.422 167.514L262.387 190.645C263.866 191.5 264.68 192.7 264.68 194.026C264.68 195.595 263.529 197.163 261.51 198.332L223.972 220.06C221.953 221.228 219.355 221.825 216.897 221.825V221.832ZM216.944 166.98C214.612 166.98 212.155 167.553 210.23 168.659L172.691 190.386C170.915 191.414 169.89 192.755 169.89 194.057C169.89 195.108 170.571 196.089 171.815 196.803L211.78 219.934C214.8 221.683 220.098 221.456 223.604 219.424L261.142 197.697C262.919 196.669 263.944 195.328 263.944 194.026C263.944 192.975 263.263 192.002 262.019 191.281L222.047 168.149C220.685 167.357 218.854 166.972 216.937 166.972L216.944 166.98Z",
    fill: "#6EE8FC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M278.994 187.382C276.685 187.382 274.47 186.904 272.772 185.915L232.808 162.784C230.859 161.654 229.787 160.007 229.787 158.14C229.787 156.03 231.204 153.999 233.684 152.563L271.223 130.836C275.394 128.42 281.552 128.192 285.238 130.326L325.211 153.457C327.159 154.587 328.231 156.234 328.231 158.101C328.231 160.211 326.815 162.243 324.334 163.678L286.796 185.405C284.542 186.708 281.709 187.374 279.001 187.374L278.994 187.382ZM279.041 132.522C276.959 132.522 274.737 133.032 273.046 134.012L235.508 155.74C233.982 156.626 233.434 157.56 233.434 158.148C233.434 158.83 234.185 159.364 234.631 159.623L274.596 182.754C277.17 184.245 281.912 184.009 284.957 182.252L322.495 160.525C324.021 159.638 324.569 158.705 324.569 158.117C324.569 157.434 323.818 156.901 323.372 156.642L283.399 133.51C282.257 132.852 280.692 132.53 279.033 132.53L279.041 132.522Z",
    fill: "#6EE8FC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M278.978 185.907C276.927 185.907 274.971 185.492 273.508 184.645L233.543 161.513C232.064 160.658 231.25 159.458 231.25 158.132C231.25 156.564 232.4 154.995 234.419 153.826L271.958 132.099C275.66 129.957 281.286 129.73 284.51 131.589L324.475 154.72C325.954 155.575 326.768 156.775 326.768 158.101C326.768 159.67 325.617 161.239 323.606 162.407L286.067 184.135C284.048 185.304 281.45 185.9 278.993 185.9L278.978 185.907ZM279.024 131.055C276.692 131.055 274.235 131.628 272.31 132.734L234.772 154.461C232.995 155.489 231.97 156.83 231.97 158.132C231.97 159.183 232.651 160.156 233.895 160.878L273.86 184.009C276.88 185.758 282.178 185.531 285.684 183.499L323.223 161.772C324.999 160.744 326.024 159.403 326.024 158.101C326.024 157.05 325.343 156.077 324.099 155.356L284.134 132.224C282.773 131.432 280.942 131.047 279.024 131.047V131.055Z",
    fill: "#6EE8FC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.936 172.644L81.8765 151.771C80.8436 151.175 80.9688 150.124 82.1661 149.434L117.647 128.898C118.844 128.208 120.652 128.13 121.685 128.734L157.744 149.606C158.777 150.202 158.652 151.253 157.455 151.944L121.974 172.479C120.777 173.169 118.969 173.248 117.936 172.644Z",
    fill: "#071033"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8765 151.779L83.6294 152.791L117.647 133.103C118.844 132.412 120.652 132.334 121.685 132.938L155.991 152.791L157.455 151.944C158.652 151.253 158.777 150.202 157.744 149.606L121.685 128.734C120.652 128.137 118.836 128.208 117.647 128.898L82.1661 149.434C80.9688 150.124 80.8436 151.175 81.8765 151.771V151.779Z",
    fill: "#0D143A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 0,
    width: 77,
    height: 174
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M117.937 172.644L81.8773 151.771C80.8443 151.175 80.7583 5.44364 81.9556 4.75338L117.115 0.572601C118.313 -0.117659 120.12 -0.196098 121.153 0.40788L156.446 4.76123C157.479 5.35736 158.653 151.261 157.456 151.951L121.975 172.487C120.778 173.177 118.97 173.255 117.937 172.651V172.644Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_392)"
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M148.307 152.289H136.295L122.929 144.555C121.208 143.558 118.203 143.684 116.215 144.837L103.327 152.297H91.3223V160.376C91.2753 161.05 91.6509 161.701 92.4726 162.18L116.685 176.197C118.406 177.193 121.411 177.067 123.399 175.914L146.648 162.462C147.681 161.866 148.229 161.105 148.284 160.376H148.292V152.297L148.307 152.289Z",
    fill: "url(#paint3_linear_1_392)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.663 161.897L123.414 175.35C121.426 176.503 118.421 176.628 116.7 175.632L92.4876 161.615C91.6581 161.137 91.2825 160.486 91.3373 159.811V160.368C91.2903 161.042 91.6659 161.693 92.4876 162.172L116.7 176.189C118.421 177.185 121.426 177.06 123.414 175.907L146.663 162.454C147.696 161.858 148.244 161.097 148.299 160.368H148.307V159.811H148.299C148.244 160.54 147.696 161.293 146.663 161.897Z",
    fill: "url(#paint4_linear_1_392)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0813 160.925V152.846H104.086L116.974 145.386C118.962 144.233 121.967 144.108 123.688 145.104L137.054 152.838H148.307V152.281H136.295L122.929 144.547C121.208 143.551 118.203 143.676 116.215 144.829L103.327 152.289H91.3223V160.368C91.2753 161.042 91.6509 161.693 92.4726 162.172L92.6056 162.25C92.2144 161.85 92.0422 161.395 92.0735 160.925H92.0813Z",
    fill: "#D4088C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M147.626 152.932V160.972H147.618C147.587 161.388 147.391 161.803 147.047 162.203C147.837 161.654 148.252 160.995 148.299 160.36H148.307V152.359C148.056 152.524 147.829 152.704 147.626 152.924V152.932Z",
    fill: "#6EE8FC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M116.693 168.102L92.4812 154.085C90.7596 153.089 90.9787 151.347 92.9664 150.194L116.216 136.742C118.203 135.589 121.208 135.464 122.93 136.46L147.142 150.477C148.864 151.473 148.645 153.214 146.657 154.367L123.407 167.82C121.42 168.973 118.415 169.098 116.693 168.102Z",
    fill: "url(#paint5_linear_1_392)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M147.142 150.485L122.93 136.468C122.038 135.95 120.802 135.738 119.542 135.809C120.457 135.864 121.318 136.083 121.983 136.468L146.195 150.485C147.917 151.481 147.698 153.222 145.71 154.375L122.461 167.827C121.506 168.384 120.309 168.698 119.135 168.761C120.59 168.847 122.187 168.533 123.407 167.827L146.657 154.375C148.645 153.222 148.864 151.481 147.142 150.485Z",
    fill: "#6EE8FC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M117.491 164.062L99.4607 153.63C98.1774 152.885 98.3417 151.591 99.8207 150.736L117.131 140.719C118.61 139.864 120.848 139.77 122.131 140.515L140.161 150.947C141.444 151.693 141.28 152.987 139.801 153.842L122.491 163.858C121.012 164.713 118.774 164.807 117.491 164.062Z",
    fill: "url(#paint6_linear_1_392)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 160.823L105.072 153.261C104.141 152.72 104.258 151.787 105.33 151.167L117.875 143.911C118.947 143.292 120.566 143.221 121.498 143.762L134.558 151.324C135.49 151.865 135.372 152.799 134.3 153.418L121.756 160.674C120.684 161.293 119.064 161.364 118.133 160.823Z",
    fill: "#6DE0F6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.781 168.102L93.569 154.085C91.8474 153.089 92.0665 151.348 94.0541 150.195L117.304 136.743C118.25 136.194 119.424 135.888 120.575 135.809C119.096 135.707 117.46 136.021 116.216 136.743L92.9664 150.195C90.9787 151.348 90.7596 153.089 92.4812 154.085L116.693 168.102C117.601 168.628 118.853 168.84 120.136 168.753C119.252 168.691 118.423 168.471 117.781 168.102Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 143,
    width: 32,
    height: 19
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 160.823L105.072 153.261C104.141 152.72 104.258 151.787 105.33 151.167L117.875 143.911C118.947 143.292 120.566 143.221 121.498 143.762L134.558 151.324C135.49 151.865 135.372 152.799 134.3 153.418L121.756 160.674C120.684 161.293 119.064 161.364 118.133 160.823Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.323 152.187L117.867 144.923C118.939 144.303 120.559 144.233 121.49 144.774L134.559 152.336C134.762 152.453 134.911 152.594 135.013 152.743C135.326 152.234 135.193 151.677 134.559 151.308L121.49 143.747C120.559 143.205 118.939 143.276 117.867 143.896L105.323 151.159C104.486 151.645 104.243 152.312 104.603 152.845C104.752 152.61 104.979 152.375 105.323 152.179V152.187Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.322 153.418L117.867 146.155C118.939 145.535 120.559 145.465 121.49 146.006L134.558 153.567C134.723 153.661 134.84 153.771 134.942 153.889C135.357 153.348 135.247 152.728 134.558 152.336L121.49 144.774C120.559 144.233 118.939 144.304 117.867 144.923L105.322 152.187C104.438 152.697 104.219 153.426 104.681 153.967C104.829 153.771 105.041 153.591 105.322 153.426V153.418Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.807 155.332C104.948 155.191 105.112 155.05 105.323 154.924L117.868 147.661C118.94 147.041 120.559 146.971 121.491 147.512L134.559 155.073C134.661 155.128 134.739 155.191 134.817 155.262C135.365 154.689 135.303 153.999 134.559 153.567L121.491 146.006C120.559 145.465 118.94 145.535 117.868 146.155L105.323 153.418C104.369 153.975 104.173 154.783 104.807 155.332Z",
    fill: "#18D0F7"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M148.307 134.656H136.295L122.929 126.922C121.208 125.925 118.203 126.051 116.215 127.204L103.327 134.664H91.3223V142.743C91.2753 143.417 91.6509 144.068 92.4726 144.547L116.685 158.564C118.406 159.56 121.411 159.434 123.399 158.281L146.648 144.829C147.681 144.233 148.229 143.472 148.284 142.743H148.292V134.664L148.307 134.656Z",
    fill: "url(#paint7_linear_1_392)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M146.663 144.264L123.414 157.717C121.426 158.87 118.421 158.995 116.7 157.999L92.4876 143.982C91.6581 143.504 91.2825 142.853 91.3373 142.178V142.735C91.2903 143.409 91.6659 144.06 92.4876 144.539L116.7 158.556C118.421 159.552 121.426 159.427 123.414 158.274L146.663 144.821C147.696 144.225 148.244 143.464 148.299 142.735H148.307V142.178H148.299C148.244 142.907 147.696 143.66 146.663 144.264Z",
    fill: "url(#paint8_linear_1_392)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0813 143.292V135.213H104.086L116.974 127.753C118.962 126.6 121.967 126.475 123.688 127.471L137.054 135.205H148.307V134.648H136.295L122.929 126.914C121.208 125.918 118.203 126.043 116.215 127.196L103.327 134.656H91.3223V142.735C91.2753 143.409 91.6509 144.06 92.4726 144.539L92.6056 144.617C92.2144 144.217 92.0422 143.762 92.0735 143.292H92.0813Z",
    fill: "#D4088C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.626 135.299V143.339H147.618C147.587 143.755 147.391 144.17 147.047 144.57C147.837 144.021 148.252 143.362 148.299 142.727H148.307V134.726C148.056 134.891 147.829 135.071 147.626 135.291V135.299Z",
    fill: "#6EE8FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.693 150.469L92.4812 136.452C90.7596 135.456 90.9787 133.714 92.9664 132.561L116.216 119.109C118.203 117.956 121.208 117.831 122.93 118.827L147.142 132.844C148.864 133.84 148.645 135.581 146.657 136.734L123.407 150.187C121.42 151.34 118.415 151.465 116.693 150.469Z",
    fill: "url(#paint9_linear_1_392)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M147.142 132.852L122.93 118.835C122.038 118.317 120.802 118.105 119.542 118.176C120.457 118.231 121.318 118.45 121.983 118.835L146.195 132.852C147.917 133.848 147.698 135.589 145.71 136.742L122.461 150.194C121.506 150.751 120.309 151.065 119.135 151.128C120.59 151.214 122.187 150.9 123.407 150.194L146.657 136.742C148.645 135.589 148.864 133.848 147.142 132.852Z",
    fill: "#6EE8FC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M117.491 146.429L99.4607 135.997C98.1774 135.252 98.3417 133.958 99.8207 133.103L117.131 123.086C118.61 122.231 120.848 122.137 122.131 122.882L140.161 133.314C141.444 134.06 141.28 135.354 139.801 136.209L122.491 146.225C121.012 147.08 118.774 147.174 117.491 146.429Z",
    fill: "url(#paint10_linear_1_392)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 143.182L105.072 135.62C104.141 135.079 104.258 134.146 105.33 133.526L117.875 126.271C118.947 125.651 120.566 125.58 121.498 126.122L134.558 133.683C135.49 134.224 135.372 135.158 134.3 135.777L121.756 143.033C120.684 143.653 119.064 143.723 118.133 143.182Z",
    fill: "#6DE0F6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M117.781 150.469L93.569 136.452C91.8474 135.456 92.0665 133.715 94.0541 132.562L117.304 119.11C118.25 118.561 119.424 118.255 120.575 118.176C119.096 118.074 117.46 118.388 116.216 119.11L92.9664 132.562C90.9787 133.715 90.7596 135.456 92.4812 136.452L116.693 150.469C117.601 150.995 118.853 151.207 120.136 151.12C119.252 151.058 118.423 150.838 117.781 150.469Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 125,
    width: 32,
    height: 19
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 143.182L105.072 135.62C104.141 135.079 104.258 134.146 105.33 133.526L117.875 126.271C118.947 125.651 120.566 125.58 121.498 126.122L134.558 133.683C135.49 134.224 135.372 135.158 134.3 135.777L121.756 143.033C120.684 143.653 119.064 143.723 118.133 143.182Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.323 134.554L117.867 127.29C118.939 126.67 120.559 126.6 121.49 127.141L134.559 134.703C134.762 134.82 134.911 134.961 135.013 135.111C135.326 134.601 135.193 134.044 134.559 133.675L121.49 126.114C120.559 125.572 118.939 125.643 117.867 126.263L105.323 133.526C104.486 134.012 104.243 134.679 104.603 135.212C104.752 134.977 104.979 134.742 105.323 134.546V134.554Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.322 135.785L117.867 128.522C118.939 127.902 120.559 127.832 121.49 128.373L134.558 135.934C134.723 136.028 134.84 136.138 134.942 136.256C135.357 135.715 135.247 135.095 134.558 134.703L121.49 127.141C120.559 126.6 118.939 126.671 117.867 127.29L105.322 134.554C104.438 135.064 104.219 135.793 104.681 136.334C104.829 136.138 105.041 135.958 105.322 135.793V135.785Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.807 137.699C104.948 137.558 105.112 137.417 105.323 137.291L117.868 130.028C118.94 129.408 120.559 129.338 121.491 129.879L134.559 137.44C134.661 137.495 134.739 137.558 134.817 137.629C135.365 137.056 135.303 136.366 134.559 135.934L121.491 128.373C120.559 127.832 118.94 127.902 117.868 128.522L105.323 135.785C104.369 136.342 104.173 137.15 104.807 137.699Z",
    fill: "#18D0F7"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.184 116.693L104.445 118.168V134.656H104.453C104.43 135.016 104.625 135.369 105.071 135.628L118.132 143.19C119.063 143.731 120.683 143.66 121.755 143.041L134.299 135.785C134.902 135.44 135.192 134.993 135.176 134.569H135.192V116.701L135.184 116.693Z",
    fill: "#6DE0F6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.307 111.94L91.3223 112.497V134.977H91.3379C91.291 135.652 91.6588 136.303 92.4883 136.781L116.7 150.798C118.422 151.795 121.427 151.669 123.414 150.516L146.664 137.064C147.783 136.421 148.315 135.589 148.284 134.805H148.307V111.94Z",
    fill: "#6DE0F6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M148.307 104.418H136.295L122.929 96.6835C121.208 95.6873 118.203 95.8128 116.215 96.9659L103.327 104.425H91.3223V112.505C91.2753 113.179 91.6509 113.83 92.4726 114.309L116.685 128.326C118.406 129.322 121.411 129.196 123.399 128.043L146.648 114.591C147.681 113.995 148.229 113.234 148.284 112.505H148.292V104.425L148.307 104.418Z",
    fill: "url(#paint11_linear_1_392)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    d: "M146.663 114.026L123.414 127.479C121.426 128.632 118.421 128.757 116.7 127.761L92.4876 113.744C91.6581 113.265 91.2825 112.614 91.3373 111.94V112.497C91.2903 113.171 91.6659 113.822 92.4876 114.301L116.7 128.318C118.421 129.314 121.426 129.188 123.414 128.035L146.663 114.583C147.696 113.987 148.244 113.226 148.299 112.497H148.307V111.94H148.299C148.244 112.669 147.696 113.422 146.663 114.026Z",
    fill: "url(#paint12_linear_1_392)"
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0813 113.054V104.974H104.086L116.974 97.515C118.962 96.3619 121.967 96.2364 123.688 97.2326L137.054 104.967H148.307V104.41H136.295L122.929 96.6757C121.208 95.6795 118.203 95.805 116.215 96.958L103.327 104.418H91.3223V112.497C91.2753 113.171 91.6509 113.822 92.4726 114.301L92.6056 114.379C92.2144 113.979 92.0422 113.524 92.0735 113.054H92.0813Z",
    fill: "#D4088C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.626 105.061V113.101H147.618C147.587 113.516 147.391 113.932 147.047 114.332C147.837 113.783 148.252 113.124 148.299 112.489H148.307V104.488C148.056 104.653 147.829 104.833 147.626 105.053V105.061Z",
    fill: "#6EE8FC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M116.693 120.231L92.4812 106.214C90.7596 105.218 90.9787 103.476 92.9664 102.323L116.216 88.871C118.203 87.718 121.208 87.5925 122.93 88.5886L147.142 102.606C148.864 103.602 148.645 105.343 146.657 106.496L123.407 119.948C121.42 121.101 118.415 121.227 116.693 120.231Z",
    fill: "url(#paint13_linear_1_392)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M147.142 102.613L122.93 88.5965C122.038 88.0788 120.802 87.867 119.542 87.9376C120.457 87.9925 121.318 88.2121 121.983 88.5965L146.195 102.613C147.917 103.61 147.698 105.351 145.71 106.504L122.461 119.956C121.506 120.513 120.309 120.827 119.135 120.89C120.59 120.976 122.187 120.662 123.407 119.956L146.657 106.504C148.645 105.351 148.864 103.61 147.142 102.613Z",
    fill: "#6EE8FC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M117.491 116.191L99.4607 105.759C98.1774 105.014 98.3417 103.719 99.8207 102.864L117.131 92.8479C118.61 91.9929 120.848 91.8987 122.131 92.6439L140.161 103.076C141.444 103.821 141.28 105.116 139.801 105.971L122.491 115.987C121.012 116.842 118.774 116.936 117.491 116.191Z",
    fill: "url(#paint14_linear_1_392)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 112.944L105.072 105.382C104.141 104.841 104.258 103.908 105.33 103.288L117.875 96.0325C118.947 95.4128 120.566 95.3422 121.498 95.8834L134.558 103.445C135.49 103.986 135.372 104.92 134.3 105.539L121.756 112.795C120.684 113.414 119.064 113.485 118.133 112.944Z",
    fill: "#6DE0F6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M117.781 120.231L93.569 106.214C91.8474 105.218 92.0665 103.477 94.0541 102.324L117.304 88.8715C118.25 88.3225 119.424 88.0166 120.575 87.9381C119.096 87.8361 117.46 88.1499 116.216 88.8715L92.9664 102.324C90.9787 103.477 90.7596 105.218 92.4812 106.214L116.693 120.231C117.601 120.757 118.853 120.969 120.136 120.882C119.252 120.82 118.423 120.6 117.781 120.231Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 95,
    width: 32,
    height: 19
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 112.944L105.072 105.382C104.141 104.841 104.258 103.908 105.33 103.288L117.875 96.0325C118.947 95.4128 120.566 95.3422 121.498 95.8834L134.558 103.445C135.49 103.986 135.372 104.92 134.3 105.539L121.756 112.795C120.684 113.414 119.064 113.485 118.133 112.944Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.323 104.315L117.867 97.052C118.939 96.4324 120.559 96.3618 121.49 96.903L134.559 104.464C134.762 104.582 134.911 104.723 135.013 104.872C135.326 104.363 135.193 103.806 134.559 103.437L121.49 95.8755C120.559 95.3342 118.939 95.4048 117.867 96.0245L105.323 103.288C104.486 103.774 104.243 104.441 104.603 104.974C104.752 104.739 104.979 104.504 105.323 104.308V104.315Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.322 105.547L117.867 98.2837C118.939 97.664 120.559 97.5934 121.49 98.1346L134.558 105.696C134.723 105.79 134.84 105.9 134.942 106.018C135.357 105.476 135.247 104.857 134.558 104.465L121.49 96.9031C120.559 96.3619 118.939 96.4325 117.867 97.0522L105.322 104.316C104.438 104.825 104.219 105.555 104.681 106.096C104.829 105.9 105.041 105.72 105.322 105.555V105.547Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.807 107.461C104.948 107.32 105.112 107.179 105.323 107.053L117.868 99.7897C118.94 99.17 120.559 99.0994 121.491 99.6406L134.559 107.202C134.661 107.257 134.739 107.32 134.817 107.39C135.365 106.818 135.303 106.128 134.559 105.696L121.491 98.1346C120.559 97.5934 118.94 97.664 117.868 98.2837L105.323 105.547C104.369 106.104 104.173 106.912 104.807 107.461Z",
    fill: "#18D0F7"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3199 126.098C100.513 126.098 101.48 125.129 101.48 123.933C101.48 122.737 100.513 121.768 99.3199 121.768C98.127 121.768 97.1601 122.737 97.1601 123.933C97.1601 125.129 98.127 126.098 99.3199 126.098Z",
    fill: "#6DE0F6"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.338 129.094C106.338 130.514 105.188 131.659 103.78 131.659C102.371 131.659 101.221 130.506 101.221 129.094C101.221 127.682 102.371 126.529 103.78 126.529C105.188 126.529 106.338 127.682 106.338 129.094Z",
    fill: "#6DE0F6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M99.6961 130.467C99.6961 130.946 99.3127 131.33 98.8353 131.33C98.358 131.33 97.9745 130.946 97.9745 130.467C97.9745 129.989 98.358 129.604 98.8353 129.604C99.3127 129.604 99.6961 129.989 99.6961 130.467Z",
    fill: "#6DE0F6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M103.78 126.749C103.78 127.228 103.397 127.612 102.919 127.612C102.442 127.612 102.059 127.228 102.059 126.749C102.059 126.271 102.442 125.886 102.919 125.886C103.397 125.886 103.78 126.271 103.78 126.749Z",
    fill: "#6DE0F6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M111.465 141.111C112.078 141.111 112.576 140.612 112.576 139.997C112.576 139.382 112.078 138.884 111.465 138.884C110.851 138.884 110.353 139.382 110.353 139.997C110.353 140.612 110.851 141.111 111.465 141.111Z",
    fill: "#6DE0F6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.522 137.73C104.46 137.73 105.22 136.968 105.22 136.028C105.22 135.088 104.46 134.326 103.522 134.326C102.584 134.326 101.824 135.088 101.824 136.028C101.824 136.968 102.584 137.73 103.522 137.73Z",
    fill: "#6DE0F6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.636 134.734C111.573 134.734 112.334 133.972 112.334 133.032C112.334 132.092 111.573 131.33 110.636 131.33C109.698 131.33 108.937 132.092 108.937 133.032C108.937 133.972 109.698 134.734 110.636 134.734Z",
    fill: "#6DE0F6"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.775 123.251C142.775 124.192 142.016 124.953 141.077 124.953C140.138 124.953 139.379 124.192 139.379 123.251C139.379 122.309 140.138 121.549 141.077 121.549C142.016 121.549 142.775 122.309 142.775 123.251Z",
    fill: "#6DE0F6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M143.76 128.914C143.76 130.247 142.68 131.33 141.35 131.33C140.019 131.33 138.939 130.247 138.939 128.914C138.939 127.581 140.019 126.498 141.35 126.498C142.68 126.498 143.76 127.581 143.76 128.914Z",
    fill: "#6DE0F6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M137.728 127.008C137.728 127.604 137.251 128.083 136.656 128.083C136.061 128.083 135.584 127.604 135.584 127.008C135.584 126.412 136.061 125.933 136.656 125.933C137.251 125.933 137.728 126.412 137.728 127.008Z",
    fill: "#6DE0F6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M136.609 124.749C136.507 125.722 135.639 126.435 134.668 126.333C133.698 126.231 132.986 125.361 133.088 124.388C133.189 123.415 134.058 122.702 135.028 122.804C135.999 122.906 136.711 123.776 136.609 124.749Z",
    fill: "#6DE0F6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.024 135.903C138.962 135.903 139.722 135.141 139.722 134.201C139.722 133.261 138.962 132.499 138.024 132.499C137.086 132.499 136.326 133.261 136.326 134.201C136.326 135.141 137.086 135.903 138.024 135.903Z",
    fill: "#6DE0F6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M129.463 141.652C129.463 142.351 128.9 142.915 128.203 142.915C127.507 142.915 126.943 142.351 126.943 141.652C126.943 140.954 127.507 140.39 128.203 140.39C128.9 140.39 129.463 140.954 129.463 141.652Z",
    fill: "#6DE0F6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M131.804 139.307C132.984 139.307 133.941 138.348 133.941 137.166C133.941 135.983 132.984 135.024 131.804 135.024C130.624 135.024 129.668 135.983 129.668 137.166C129.668 138.348 130.624 139.307 131.804 139.307Z",
    fill: "#6DE0F6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.732 130.796C130.732 131.738 129.973 132.499 129.034 132.499C128.095 132.499 127.336 131.738 127.336 130.796C127.336 129.855 128.095 129.094 129.034 129.094C129.973 129.094 130.732 129.855 130.732 130.796Z",
    fill: "#6DE0F6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.866 144.868C121.866 146.272 120.731 147.418 119.322 147.418C117.914 147.418 116.779 146.28 116.779 144.868C116.779 143.456 117.914 142.319 119.322 142.319C120.731 142.319 121.866 143.456 121.866 144.868Z",
    fill: "#6DE0F6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M109.563 129.094C110.501 129.094 111.262 128.332 111.262 127.392C111.262 126.452 110.501 125.69 109.563 125.69C108.626 125.69 107.865 126.452 107.865 127.392C107.865 128.332 108.626 129.094 109.563 129.094Z",
    fill: "#6DE0F6"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.184 86.1335L104.445 87.6082V104.096H104.453C104.43 104.457 104.625 104.81 105.071 105.069L118.132 112.63C119.063 113.171 120.683 113.101 121.755 112.481L134.299 105.225C134.902 104.88 135.192 104.425 135.176 104.01H135.192V86.1414L135.184 86.1335Z",
    fill: "#6DE0F6"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M148.307 81.3801L91.3223 81.937V104.418H91.3379C91.291 105.092 91.6588 105.743 92.4883 106.222L116.7 120.239C118.422 121.235 121.427 121.109 123.414 119.956L146.664 106.504C147.783 105.861 148.315 105.029 148.284 104.245H148.307V81.3801Z",
    fill: "#6DE0F6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M148.307 73.8579H136.295L122.929 66.1238C121.208 65.1276 118.203 65.2531 116.215 66.4062L103.327 73.8657H91.3223V81.9449C91.2753 82.6195 91.6509 83.2705 92.4726 83.749L116.685 97.766C118.406 98.7621 121.411 98.6366 123.399 97.4836L146.648 84.0314C147.681 83.4352 148.229 82.6744 148.284 81.9449H148.292V73.8657L148.307 73.8579Z",
    fill: "url(#paint15_linear_1_392)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    d: "M146.663 83.4587L123.414 96.911C121.426 98.064 118.421 98.1895 116.7 97.1934L92.4876 83.1764C91.6581 82.6979 91.2825 82.0468 91.3373 81.3723V81.9292C91.2903 82.6038 91.6659 83.2548 92.4876 83.7333L116.7 97.7503C118.421 98.7464 121.426 98.6209 123.414 97.4679L146.663 84.0157C147.696 83.4195 148.244 82.6587 148.299 81.9292H148.307V81.3723H148.299C148.244 82.1018 147.696 82.8548 146.663 83.4587Z",
    fill: "url(#paint16_linear_1_392)"
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0813 82.494V74.4148H104.086L116.974 66.9553C118.962 65.8022 121.967 65.6767 123.688 66.6729L137.054 74.4069H148.307V73.85H136.295L122.929 66.116C121.208 65.1198 118.203 65.2453 116.215 66.3983L103.327 73.8579H91.3223V81.937C91.2753 82.6116 91.6509 83.2627 92.4726 83.7411L92.6056 83.8196C92.2144 83.4195 92.0422 82.9646 92.0735 82.494H92.0813Z",
    fill: "#D4088C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M147.626 74.5011V82.541H147.618C147.587 82.9567 147.391 83.3725 147.047 83.7725C147.837 83.2234 148.252 82.5645 148.299 81.9292H148.307V73.9284C148.056 74.0932 147.829 74.2736 147.626 74.4932V74.5011Z",
    fill: "#6EE8FC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M116.693 89.6711L92.4812 75.6541C90.7596 74.6579 90.9787 72.9166 92.9664 71.7635L116.216 58.3113C118.203 57.1582 121.208 57.0327 122.93 58.0289L147.142 72.0459C148.864 73.0421 148.645 74.7834 146.657 75.9365L123.407 89.3887C121.42 90.5417 118.415 90.6673 116.693 89.6711Z",
    fill: "url(#paint17_radial_1_392)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M147.142 72.0538L122.93 58.0368C122.038 57.5191 120.802 57.3073 119.542 57.3779C120.457 57.4328 121.318 57.6524 121.983 58.0368L146.195 72.0538C147.917 73.0499 147.698 74.7913 145.71 75.9443L122.461 89.3966C121.506 89.9535 120.309 90.2672 119.135 90.33C120.59 90.4163 122.187 90.1025 123.407 89.3966L146.657 75.9443C148.645 74.7913 148.864 73.0499 147.142 72.0538Z",
    fill: "#6EE8FC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M117.491 85.6315L99.4607 75.1992C98.1774 74.454 98.3417 73.1597 99.8207 72.3048L117.131 62.2882C118.61 61.4332 120.848 61.339 122.131 62.0842L140.161 72.5166C141.444 73.2617 141.28 74.556 139.801 75.4109L122.491 85.4276C121.012 86.2825 118.774 86.3767 117.491 85.6315Z",
    fill: "url(#paint18_linear_1_392)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 82.3841L105.072 74.8226C104.141 74.2814 104.258 73.348 105.33 72.7283L117.875 65.4728C118.947 64.8531 120.566 64.7825 121.498 65.3237L134.558 72.8852C135.49 73.4264 135.372 74.3599 134.3 74.9795L121.756 82.2351C120.684 82.8548 119.064 82.9254 118.133 82.3841Z",
    fill: "#6DE0F6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M117.781 89.6716L93.569 75.6546C91.8474 74.6584 92.0665 72.9171 94.0541 71.7641L117.304 58.3118C118.25 57.7627 119.424 57.4568 120.575 57.3784C119.096 57.2764 117.46 57.5902 116.216 58.3118L92.9664 71.7641C90.9787 72.9171 90.7596 74.6584 92.4812 75.6546L116.693 89.6716C117.601 90.1971 118.853 90.4089 120.136 90.3226C119.252 90.2599 118.423 90.0403 117.781 89.6716Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 64,
    width: 32,
    height: 19
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M118.133 82.3841L105.072 74.8226C104.141 74.2814 104.258 73.348 105.33 72.7283L117.875 65.4728C118.947 64.8531 120.566 64.7825 121.498 65.3237L134.558 72.8852C135.49 73.4264 135.372 74.3599 134.3 74.9795L121.756 82.2351C120.684 82.8548 119.064 82.9254 118.133 82.3841Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.323 73.7558L117.867 66.4923C118.939 65.8727 120.559 65.8021 121.49 66.3433L134.559 73.9048C134.762 74.0225 134.911 74.1636 135.013 74.3127C135.326 73.8028 135.193 73.2459 134.559 72.8773L121.49 65.3158C120.559 64.7745 118.939 64.8451 117.867 65.4648L105.323 72.7282C104.486 73.2145 104.243 73.8813 104.603 74.4146C104.752 74.1793 104.979 73.944 105.323 73.7479V73.7558Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.322 74.9874L117.867 67.724C118.939 67.1043 120.559 67.0337 121.49 67.5749L134.558 75.1364C134.723 75.2305 134.84 75.3403 134.942 75.458C135.357 74.9168 135.247 74.2971 134.558 73.9049L121.49 66.3434C120.559 65.8022 118.939 65.8728 117.867 66.4925L105.322 73.7559C104.438 74.2657 104.219 74.9952 104.681 75.5364C104.829 75.3404 105.041 75.1599 105.322 74.9952V74.9874Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.807 76.8934C104.948 76.7522 105.112 76.6111 105.323 76.4855L117.868 69.2221C118.94 68.6025 120.559 68.5319 121.491 69.0731L134.559 76.6346C134.661 76.6895 134.739 76.7522 134.817 76.8228C135.365 76.2502 135.303 75.56 134.559 75.1286L121.491 67.5671C120.559 67.0258 118.94 67.0964 117.868 67.7161L105.323 74.9795C104.369 75.5364 104.173 76.3444 104.807 76.8934Z",
    fill: "#18D0F7"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3199 95.5305C100.513 95.5305 101.48 94.5612 101.48 93.3656C101.48 92.1699 100.513 91.2006 99.3199 91.2006C98.127 91.2006 97.1601 92.1699 97.1601 93.3656C97.1601 94.5612 98.127 95.5305 99.3199 95.5305Z",
    fill: "#6DE0F6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.338 98.5347C106.338 99.9544 105.188 101.1 103.78 101.1C102.371 101.1 101.221 99.9466 101.221 98.5347C101.221 97.1228 102.371 95.9697 103.78 95.9697C105.188 95.9697 106.338 97.1228 106.338 98.5347Z",
    fill: "#6DE0F6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M99.6961 99.9073C99.6961 100.386 99.3127 100.77 98.8353 100.77C98.358 100.77 97.9745 100.386 97.9745 99.9073C97.9745 99.4289 98.358 99.0445 98.8353 99.0445C99.3127 99.0445 99.6961 99.4289 99.6961 99.9073Z",
    fill: "#6DE0F6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M103.78 96.1815C103.78 96.66 103.397 97.0443 102.919 97.0443C102.442 97.0443 102.059 96.66 102.059 96.1815C102.059 95.703 102.442 95.3187 102.919 95.3187C103.397 95.3187 103.78 95.703 103.78 96.1815Z",
    fill: "#6DE0F6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M111.465 110.551C112.078 110.551 112.576 110.053 112.576 109.438C112.576 108.822 112.078 108.324 111.465 108.324C110.851 108.324 110.353 108.822 110.353 109.438C110.353 110.053 110.851 110.551 111.465 110.551Z",
    fill: "#6DE0F6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.522 107.171C104.46 107.171 105.22 106.409 105.22 105.469C105.22 104.529 104.46 103.767 103.522 103.767C102.584 103.767 101.824 104.529 101.824 105.469C101.824 106.409 102.584 107.171 103.522 107.171Z",
    fill: "#6DE0F6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.636 104.167C111.573 104.167 112.334 103.404 112.334 102.464C112.334 101.524 111.573 100.762 110.636 100.762C109.698 100.762 108.937 101.524 108.937 102.464C108.937 103.404 109.698 104.167 110.636 104.167Z",
    fill: "#6DE0F6"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.775 92.691C142.775 93.6322 142.016 94.3931 141.077 94.3931C140.138 94.3931 139.379 93.6322 139.379 92.691C139.379 91.7497 140.138 90.9889 141.077 90.9889C142.016 90.9889 142.775 91.7497 142.775 92.691Z",
    fill: "#6DE0F6"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M143.76 98.3543C143.76 99.6877 142.68 100.77 141.35 100.77C140.019 100.77 138.939 99.6877 138.939 98.3543C138.939 97.0208 140.019 95.9383 141.35 95.9383C142.68 95.9383 143.76 97.0208 143.76 98.3543Z",
    fill: "#6DE0F6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M137.728 96.4482C137.728 97.0443 137.251 97.5228 136.656 97.5228C136.061 97.5228 135.584 97.0443 135.584 96.4482C135.584 95.8521 136.061 95.3736 136.656 95.3736C137.251 95.3736 137.728 95.8521 137.728 96.4482Z",
    fill: "#6DE0F6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M134.847 95.7815C135.823 95.7815 136.615 94.9878 136.615 94.0087C136.615 93.0297 135.823 92.236 134.847 92.236C133.87 92.236 133.078 93.0297 133.078 94.0087C133.078 94.9878 133.87 95.7815 134.847 95.7815Z",
    fill: "#6DE0F6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138.024 105.343C138.962 105.343 139.722 104.581 139.722 103.641C139.722 102.701 138.962 101.939 138.024 101.939C137.086 101.939 136.326 102.701 136.326 103.641C136.326 104.581 137.086 105.343 138.024 105.343Z",
    fill: "#6DE0F6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M129.463 111.085C129.463 111.783 128.9 112.348 128.203 112.348C127.507 112.348 126.943 111.783 126.943 111.085C126.943 110.387 127.507 109.822 128.203 109.822C128.9 109.822 129.463 110.387 129.463 111.085Z",
    fill: "#6DE0F6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M131.804 108.74C132.984 108.74 133.941 107.781 133.941 106.598C133.941 105.416 132.984 104.457 131.804 104.457C130.624 104.457 129.668 105.416 129.668 106.598C129.668 107.781 130.624 108.74 131.804 108.74Z",
    fill: "#6DE0F6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.732 100.237C130.732 101.178 129.973 101.939 129.034 101.939C128.095 101.939 127.336 101.178 127.336 100.237C127.336 99.2955 128.095 98.5347 129.034 98.5347C129.973 98.5347 130.732 99.2955 130.732 100.237Z",
    fill: "#6DE0F6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.866 114.309C121.866 115.713 120.731 116.858 119.322 116.858C117.914 116.858 116.779 115.721 116.779 114.309C116.779 112.897 117.914 111.759 119.322 111.759C120.731 111.759 121.866 112.897 121.866 114.309Z",
    fill: "#6DE0F6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M109.563 98.5347C110.501 98.5347 111.262 97.7726 111.262 96.8325C111.262 95.8925 110.501 95.1304 109.563 95.1304C108.626 95.1304 107.865 95.8925 107.865 96.8325C107.865 97.7726 108.626 98.5347 109.563 98.5347Z",
    fill: "#6DE0F6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M135.184 8.23606H104.445V73.9206C104.445 74.2579 104.649 74.5873 105.071 74.8305L118.132 82.392C119.063 82.9332 120.683 82.8626 121.755 82.243L134.299 74.9874C134.855 74.6658 135.152 74.2579 135.184 73.8657V8.23606Z",
    fill: "url(#paint19_linear_1_392)"
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 68.4142C113.664 69.0496 113.155 69.5594 112.521 69.5594C111.888 69.5594 111.379 69.0496 111.379 68.4142C111.379 67.7789 111.888 67.269 112.521 67.269C113.155 67.269 113.664 67.7789 113.664 68.4142Z",
    fill: "#6DE0F6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M121.154 62.6803C122.234 62.6803 123.11 61.8024 123.11 60.7194C123.11 59.6364 122.234 58.7584 121.154 58.7584C120.073 58.7584 119.197 59.6364 119.197 60.7194C119.197 61.8024 120.073 62.6803 121.154 62.6803Z",
    fill: "#6DE0F6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M118.743 59.9742C119.02 59.9742 119.244 59.7495 119.244 59.4722C119.244 59.195 119.02 58.9702 118.743 58.9702C118.466 58.9702 118.242 59.195 118.242 59.4722C118.242 59.7495 118.466 59.9742 118.743 59.9742Z",
    fill: "#6DE0F6"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M128.259 49.636C128.259 50.1772 127.821 50.6165 127.281 50.6165C126.741 50.6165 126.303 50.1772 126.303 49.636C126.303 49.0948 126.741 48.6555 127.281 48.6555C127.821 48.6555 128.259 49.0948 128.259 49.636Z",
    fill: "#6DE0F6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M122.821 41.3215C122.821 41.7058 122.508 42.0118 122.132 42.0118C121.756 42.0118 121.443 41.698 121.443 41.3215C121.443 40.945 121.756 40.6312 122.132 40.6312C122.508 40.6312 122.821 40.945 122.821 41.3215Z",
    fill: "#6DE0F6"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M114.916 36.0112C114.916 36.7015 114.353 37.2662 113.664 37.2662C112.976 37.2662 112.412 36.7015 112.412 36.0112C112.412 35.3209 112.976 34.7562 113.664 34.7562C114.353 34.7562 114.916 35.3209 114.916 36.0112Z",
    fill: "#6DE0F6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M120.575 29.6655C121.975 29.6655 123.11 28.5277 123.11 27.1241C123.11 25.7205 121.975 24.5827 120.575 24.5827C119.174 24.5827 118.039 25.7205 118.039 27.1241C118.039 28.5277 119.174 29.6655 120.575 29.6655Z",
    fill: "#6DE0F6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M117.341 26.2142C117.726 26.2142 118.037 25.9016 118.037 25.5161C118.037 25.1305 117.726 24.818 117.341 24.818C116.956 24.818 116.645 25.1305 116.645 25.5161C116.645 25.9016 116.956 26.2142 117.341 26.2142Z",
    fill: "#6DE0F6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M123.438 30.1754C123.438 30.6303 123.07 30.999 122.617 30.999C122.163 30.999 121.795 30.6303 121.795 30.1754C121.795 29.7204 122.163 29.3518 122.617 29.3518C123.07 29.3518 123.438 29.7204 123.438 30.1754Z",
    fill: "#6DE0F6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M123.649 28.8497C123.87 28.8497 124.048 28.6706 124.048 28.4497C124.048 28.2288 123.87 28.0497 123.649 28.0497C123.429 28.0497 123.25 28.2288 123.25 28.4497C123.25 28.6706 123.429 28.8497 123.649 28.8497Z",
    fill: "#6DE0F6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M129.213 19.8842C129.213 20.5196 128.696 21.0373 128.062 21.0373C127.429 21.0373 126.912 20.5196 126.912 19.8842C126.912 19.2489 127.429 18.7312 128.062 18.7312C128.696 18.7312 129.213 19.2489 129.213 19.8842Z",
    fill: "#6DE0F6"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M91.612 216.867L55.5523 195.995C54.5194 195.399 54.6446 194.348 55.8419 193.657L91.3225 173.122C92.5198 172.432 94.3274 172.353 95.3604 172.957L131.42 193.83C132.453 194.426 132.328 195.477 131.131 196.167L95.6499 216.703C94.4526 217.393 92.645 217.471 91.612 216.867Z",
    fill: "#071033"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5445 195.995L57.2974 197.007L91.3147 177.318C92.5119 176.628 94.3196 176.55 95.3526 177.154L129.659 197.007L131.123 196.159C132.32 195.469 132.445 194.418 131.412 193.822L95.3526 172.949C94.3196 172.353 92.5041 172.424 91.3147 173.114L55.834 193.649C54.6367 194.34 54.5115 195.391 55.5445 195.987V195.995Z",
    fill: "#0D143A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.3,
    d: "M154.85 174.699C154.85 205.156 123.289 230.21 109.345 230.21C95.3995 230.21 84.0918 205.517 84.0918 175.067C84.0918 144.617 95.3995 119.925 109.345 119.925C123.289 119.925 154.85 144.249 154.85 174.699Z",
    fill: "url(#paint20_radial_1_392)"
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M121.983 196.505H109.971L96.6051 188.771C94.8835 187.774 91.8785 187.9 89.8908 189.053L77.0023 196.512H64.998V204.592C64.9511 205.266 65.3267 205.917 66.1484 206.396L90.3603 220.413C92.0819 221.409 95.0869 221.283 97.0746 220.13L120.324 206.678C121.357 206.082 121.905 205.321 121.96 204.592H121.967V196.512L121.983 196.505Z",
    fill: "url(#paint21_linear_1_392)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M120.331 206.113L97.0818 219.566C95.0941 220.719 92.0891 220.844 90.3675 219.848L66.1556 205.831C65.3261 205.352 64.9504 204.701 65.0052 204.027V204.584C64.9583 205.258 65.3339 205.909 66.1556 206.388L90.3675 220.405C92.0891 221.401 95.0941 221.276 97.0818 220.122L120.331 206.67C121.364 206.074 121.912 205.313 121.967 204.584H121.975V204.027H121.967C121.912 204.756 121.364 205.509 120.331 206.113Z",
    fill: "url(#paint22_linear_1_392)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7571 205.141V197.061H77.7614L90.6499 189.602C92.6376 188.449 95.6425 188.323 97.3641 189.32L110.73 197.054H121.983V196.497H109.971L96.6051 188.763C94.8835 187.766 91.8785 187.892 89.8908 189.045L77.0023 196.505H64.998V204.584C64.9511 205.258 65.3267 205.909 66.1484 206.388L66.2814 206.466C65.8902 206.066 65.718 205.611 65.7493 205.141H65.7571Z",
    fill: "#D4088C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M121.294 197.156V205.196H121.286C121.255 205.611 121.059 206.027 120.715 206.427C121.505 205.878 121.92 205.219 121.967 204.584H121.975V196.583C121.724 196.748 121.497 196.928 121.294 197.148V197.156Z",
    fill: "#6EE8FC"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.369 212.326L66.157 198.309C64.4354 197.313 64.6545 195.571 66.6422 194.418L89.8916 180.966C91.8793 179.813 94.8842 179.687 96.6058 180.684L120.818 194.701C122.539 195.697 122.32 197.438 120.333 198.591L97.0832 212.043C95.0955 213.196 92.0906 213.322 90.369 212.326Z",
    fill: "url(#paint23_radial_1_392)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M120.818 194.7L96.6059 180.683C95.7138 180.166 94.4774 179.954 93.2175 180.025C94.1331 180.079 94.9938 180.299 95.659 180.683L119.871 194.7C121.593 195.697 121.373 197.438 119.386 198.591L96.1364 212.043C95.1817 212.6 93.9844 212.914 92.8105 212.977C94.2661 213.063 95.8625 212.749 97.0832 212.043L120.333 198.591C122.32 197.438 122.539 195.697 120.818 194.7Z",
    fill: "#6EE8FC"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1664 208.278L73.1365 197.846C71.8532 197.101 72.0175 195.806 73.4965 194.951L90.8064 184.935C92.2854 184.08 94.5235 183.986 95.8069 184.731L113.837 195.163C115.12 195.908 114.956 197.203 113.477 198.058L96.1668 208.074C94.6878 208.929 92.4497 209.023 91.1664 208.278Z",
    fill: "url(#paint24_linear_1_392)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 205.039L78.7479 197.477C77.8166 196.936 77.934 196.003 79.0061 195.383L91.5503 188.127C92.6224 187.508 94.2423 187.437 95.1735 187.978L108.234 195.54C109.165 196.081 109.048 197.014 107.976 197.634L95.4317 204.89C94.3596 205.509 92.7398 205.58 91.8085 205.039Z",
    fill: "#6DE0F6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4567 212.326L67.2447 198.309C65.5231 197.313 65.7422 195.572 67.7299 194.419L90.9793 180.966C91.9262 180.417 93.1 180.111 94.2504 180.033C92.7714 179.931 91.1358 180.245 89.8916 180.966L66.6422 194.419C64.6545 195.572 64.4354 197.313 66.157 198.309L90.369 212.326C91.2767 212.852 92.5288 213.063 93.8122 212.977C92.9279 212.914 92.0984 212.695 91.4567 212.326Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 187,
    width: 31,
    height: 19
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 205.039L78.7479 197.477C77.8166 196.936 77.934 196.003 79.0061 195.383L91.5503 188.127C92.6224 187.508 94.2423 187.437 95.1735 187.978L108.234 195.54C109.165 196.081 109.048 197.014 107.976 197.634L95.4317 204.89C94.3596 205.509 92.7398 205.58 91.8085 205.039Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9986 196.402L91.5428 189.139C92.6149 188.519 94.2348 188.449 95.166 188.99L108.235 196.551C108.438 196.669 108.587 196.81 108.688 196.959C109.001 196.449 108.868 195.893 108.235 195.524L95.166 187.962C94.2348 187.421 92.6149 187.492 91.5428 188.111L78.9986 195.375C78.1613 195.861 77.9187 196.528 78.2787 197.061C78.4274 196.826 78.6543 196.591 78.9986 196.395V196.402Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9982 197.634L91.5424 190.371C92.6145 189.751 94.2344 189.68 95.1656 190.222L108.234 197.783C108.398 197.877 108.516 197.987 108.618 198.105C109.032 197.563 108.923 196.944 108.234 196.552L95.1656 188.99C94.2344 188.449 92.6145 188.52 91.5424 189.139L78.9982 196.403C78.1139 196.912 77.8948 197.642 78.3565 198.183C78.5052 197.987 78.7165 197.799 78.9982 197.642V197.634Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4826 199.548C78.6235 199.407 78.7878 199.266 78.9991 199.14L91.5433 191.877C92.6154 191.257 94.2352 191.186 95.1665 191.728L108.235 199.289C108.337 199.344 108.415 199.407 108.493 199.477C109.041 198.905 108.978 198.215 108.235 197.783L95.1665 190.222C94.2352 189.68 92.6154 189.751 91.5433 190.371L78.9991 197.634C78.0444 198.191 77.8487 198.999 78.4826 199.548Z",
    fill: "#18D0F7"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M121.983 178.872H109.971L96.6051 171.137C94.8835 170.141 91.8785 170.267 89.8908 171.42L77.0023 178.879H64.998V186.959C64.9511 187.633 65.3267 188.284 66.1484 188.763L90.3603 202.78C92.0819 203.776 95.0869 203.65 97.0746 202.497L120.324 189.045C121.357 188.449 121.905 187.688 121.96 186.959H121.967V178.879L121.983 178.872Z",
    fill: "url(#paint25_linear_1_392)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M120.331 188.48L97.0818 201.933C95.0941 203.086 92.0891 203.211 90.3675 202.215L66.1556 188.198C65.3261 187.719 64.9504 187.068 65.0052 186.394V186.951C64.9583 187.625 65.3339 188.276 66.1556 188.755L90.3675 202.772C92.0891 203.768 95.0941 203.642 97.0818 202.489L120.331 189.037C121.364 188.441 121.912 187.68 121.967 186.951H121.975V186.394H121.967C121.912 187.123 121.364 187.876 120.331 188.48Z",
    fill: "url(#paint26_linear_1_392)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7571 187.508V179.428H77.7614L90.6499 171.969C92.6376 170.816 95.6425 170.69 97.3641 171.687L110.73 179.421H121.983V178.864H109.971L96.6051 171.13C94.8835 170.133 91.8785 170.259 89.8908 171.412L77.0023 178.872H64.998V186.951C64.9511 187.625 65.3267 188.276 66.1484 188.755L66.2814 188.833C65.8902 188.433 65.718 187.978 65.7493 187.508H65.7571Z",
    fill: "#D4088C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M121.294 179.523V187.563H121.286C121.255 187.978 121.059 188.394 120.715 188.794C121.505 188.245 121.92 187.586 121.967 186.951H121.975V178.95C121.724 179.115 121.497 179.295 121.294 179.515V179.523Z",
    fill: "#6EE8FC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90.369 194.693L66.157 180.676C64.4354 179.679 64.6545 177.938 66.6422 176.785L89.8916 163.333C91.8793 162.18 94.8842 162.054 96.6058 163.05L120.818 177.067C122.539 178.064 122.32 179.805 120.333 180.958L97.0832 194.41C95.0955 195.563 92.0906 195.689 90.369 194.693Z",
    fill: "url(#paint27_linear_1_392)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M120.818 177.067L96.6059 163.05C95.7138 162.533 94.4774 162.321 93.2175 162.392C94.1331 162.446 94.9938 162.666 95.659 163.05L119.871 177.067C121.593 178.064 121.373 179.805 119.386 180.958L96.1364 194.41C95.1817 194.967 93.9844 195.281 92.8105 195.344C94.2661 195.43 95.8625 195.116 97.0832 194.41L120.333 180.958C122.32 179.805 122.539 178.064 120.818 177.067Z",
    fill: "#6EE8FC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1664 190.645L73.1365 180.213C71.8532 179.468 72.0175 178.173 73.4965 177.318L90.8064 167.302C92.2854 166.447 94.5235 166.353 95.8069 167.098L113.837 177.53C115.12 178.275 114.956 179.57 113.477 180.425L96.1668 190.441C94.6878 191.296 92.4497 191.39 91.1664 190.645Z",
    fill: "url(#paint28_linear_1_392)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 187.406L78.7479 179.844C77.8166 179.303 77.934 178.37 79.0061 177.75L91.5503 170.494C92.6224 169.875 94.2423 169.804 95.1735 170.345L108.234 177.907C109.165 178.448 109.048 179.381 107.976 180.001L95.4317 187.257C94.3596 187.876 92.7398 187.947 91.8085 187.406Z",
    fill: "#6DE0F6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4567 194.693L67.2447 180.676C65.5231 179.68 65.7422 177.939 67.7299 176.786L90.9793 163.333C91.9262 162.784 93.1 162.478 94.2504 162.4C92.7714 162.298 91.1358 162.612 89.8916 163.333L66.6422 176.786C64.6545 177.939 64.4354 179.68 66.157 180.676L90.369 194.693C91.2767 195.219 92.5288 195.43 93.8122 195.344C92.9279 195.281 92.0984 195.062 91.4567 194.693Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 169,
    width: 31,
    height: 19
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 187.406L78.7479 179.844C77.8166 179.303 77.934 178.37 79.0061 177.75L91.5503 170.494C92.6224 169.875 94.2423 169.804 95.1735 170.345L108.234 177.907C109.165 178.448 109.048 179.381 107.976 180.001L95.4317 187.257C94.3596 187.876 92.7398 187.947 91.8085 187.406Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9986 178.769L91.5428 171.506C92.6149 170.886 94.2348 170.816 95.166 171.357L108.235 178.918C108.438 179.036 108.587 179.177 108.688 179.326C109.001 178.816 108.868 178.26 108.235 177.891L95.166 170.329C94.2348 169.788 92.6149 169.859 91.5428 170.478L78.9986 177.742C78.1613 178.228 77.9187 178.895 78.2787 179.428C78.4274 179.193 78.6543 178.958 78.9986 178.762V178.769Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9982 180.001L91.5424 172.738C92.6145 172.118 94.2344 172.047 95.1656 172.589L108.234 180.15C108.398 180.244 108.516 180.354 108.618 180.472C109.032 179.93 108.923 179.311 108.234 178.919L95.1656 171.357C94.2344 170.816 92.6145 170.886 91.5424 171.506L78.9982 178.77C78.1139 179.279 77.8948 180.009 78.3565 180.55C78.5052 180.354 78.7165 180.174 78.9982 180.009V180.001Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4826 181.915C78.6235 181.774 78.7878 181.633 78.9991 181.507L91.5433 174.244C92.6154 173.624 94.2352 173.553 95.1665 174.095L108.235 181.656C108.337 181.711 108.415 181.774 108.493 181.844C109.041 181.272 108.978 180.582 108.235 180.15L95.1665 172.589C94.2352 172.047 92.6154 172.118 91.5433 172.738L78.9991 180.001C78.0444 180.558 77.8487 181.366 78.4826 181.915Z",
    fill: "#18D0F7"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.852 160.909L78.1135 162.384V178.872H78.1214C78.0979 179.232 78.2935 179.585 78.7396 179.844L91.8002 187.406C92.7315 187.947 94.3513 187.876 95.4234 187.257L107.968 180.001C108.57 179.656 108.86 179.209 108.844 178.785H108.86V160.917L108.852 160.909Z",
    fill: "#6DE0F6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121.983 156.156L64.998 156.713V179.193H65.0137C64.9667 179.868 65.3345 180.519 66.164 180.997L90.376 195.014C92.0976 196.01 95.1026 195.885 97.0902 194.732L120.34 181.28C121.459 180.636 121.991 179.805 121.96 179.021H121.983V156.156Z",
    fill: "#6DE0F6"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M121.983 148.633H109.971L96.6051 140.899C94.8835 139.903 91.8785 140.029 89.8908 141.182L77.0023 148.641H64.998V156.72C64.9511 157.395 65.3267 158.046 66.1484 158.525L90.3603 172.542C92.0819 173.538 95.0869 173.412 97.0746 172.259L120.324 158.807C121.357 158.211 121.905 157.45 121.96 156.72H121.967V148.641L121.983 148.633Z",
    fill: "url(#paint29_linear_1_392)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    d: "M120.331 158.242L97.0818 171.694C95.0941 172.847 92.0891 172.973 90.3675 171.977L66.1556 157.96C65.3261 157.481 64.9504 156.83 65.0052 156.156V156.713C64.9583 157.387 65.3339 158.038 66.1556 158.517L90.3675 172.534C92.0891 173.53 95.0941 173.404 97.0818 172.251L120.331 158.799C121.364 158.203 121.912 157.442 121.967 156.713H121.975V156.156H121.967C121.912 156.885 121.364 157.638 120.331 158.242Z",
    fill: "url(#paint30_linear_1_392)"
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7571 157.27V149.19H77.7614L90.6499 141.731C92.6376 140.578 95.6425 140.452 97.3641 141.448L110.73 149.183H121.983V148.626H109.971L96.6051 140.892C94.8835 139.895 91.8785 140.021 89.8908 141.174L77.0023 148.633H64.998V156.713C64.9511 157.387 65.3267 158.038 66.1484 158.517L66.2814 158.595C65.8902 158.195 65.718 157.74 65.7493 157.27H65.7571Z",
    fill: "#D4088C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M121.294 149.284V157.324H121.286C121.255 157.74 121.059 158.156 120.715 158.556C121.505 158.007 121.92 157.348 121.967 156.713H121.975V148.712C121.724 148.877 121.497 149.057 121.294 149.277V149.284Z",
    fill: "#6EE8FC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M90.369 164.455L66.157 150.438C64.4354 149.441 64.6545 147.7 66.6422 146.547L89.8916 133.095C91.8793 131.942 94.8842 131.816 96.6058 132.812L120.818 146.829C122.539 147.826 122.32 149.567 120.333 150.72L97.0832 164.172C95.0955 165.325 92.0906 165.451 90.369 164.455Z",
    fill: "url(#paint31_radial_1_392)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M120.818 146.829L96.6059 132.812C95.7138 132.295 94.4774 132.083 93.2175 132.153C94.1331 132.208 94.9938 132.428 95.659 132.812L119.871 146.829C121.593 147.826 121.373 149.567 119.386 150.72L96.1364 164.172C95.1817 164.729 93.9844 165.043 92.8105 165.106C94.2661 165.192 95.8625 164.878 97.0832 164.172L120.333 150.72C122.32 149.567 122.539 147.826 120.818 146.829Z",
    fill: "#6EE8FC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1664 160.407L73.1365 149.975C71.8532 149.23 72.0175 147.935 73.4965 147.08L90.8064 137.064C92.2854 136.209 94.5235 136.115 95.8069 136.86L113.837 147.292C115.12 148.037 114.956 149.332 113.477 150.187L96.1668 160.203C94.6878 161.058 92.4497 161.152 91.1664 160.407Z",
    fill: "url(#paint32_linear_1_392)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 157.168L78.7479 149.606C77.8166 149.065 77.934 148.131 79.0061 147.512L91.5503 140.256C92.6224 139.637 94.2423 139.566 95.1735 140.107L108.234 147.669C109.165 148.21 109.048 149.143 107.976 149.763L95.4317 157.019C94.3596 157.638 92.7398 157.709 91.8085 157.168Z",
    fill: "#6DE0F6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4567 164.455L67.2447 150.438C65.5231 149.441 65.7422 147.7 67.7299 146.547L90.9793 133.095C91.9262 132.546 93.1 132.24 94.2504 132.161C92.7714 132.059 91.1358 132.373 89.8916 133.095L66.6422 146.547C64.6545 147.7 64.4354 149.441 66.157 150.438L90.369 164.455C91.2767 164.98 92.5288 165.192 93.8122 165.106C92.9279 165.043 92.0984 164.823 91.4567 164.455Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M108.852 83.0117H78.1135V148.696C78.1135 149.033 78.317 149.363 78.7396 149.606L91.8002 157.168C92.7315 157.709 94.3513 157.638 95.4234 157.019L107.968 149.763C108.523 149.441 108.821 149.033 108.852 148.641V83.0195V83.0117Z",
    fill: "url(#paint33_linear_1_392)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.25,
    d: "M107.396 89.2789H79.5762V148.728C79.5762 149.033 79.764 149.332 80.1396 149.551L91.9639 156.391C92.8012 156.877 94.2724 156.815 95.2427 156.258L106.59 149.692C107.09 149.402 107.364 149.033 107.388 148.681V89.2946L107.396 89.2789Z",
    fill: "url(#paint34_linear_1_392)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 139,
    width: 31,
    height: 19
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8085 157.168L78.7479 149.606C77.8166 149.065 77.934 148.131 79.0061 147.512L91.5503 140.256C92.6224 139.637 94.2423 139.566 95.1735 140.107L108.234 147.669C109.165 148.21 109.048 149.143 107.976 149.763L95.4317 157.019C94.3596 157.638 92.7398 157.709 91.8085 157.168Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9986 148.531L91.5428 141.268C92.6149 140.648 94.2348 140.578 95.166 141.119L108.235 148.68C108.438 148.798 108.587 148.939 108.688 149.088C109.001 148.578 108.868 148.021 108.235 147.653L95.166 140.091C94.2348 139.55 92.6149 139.621 91.5428 140.24L78.9986 147.504C78.1613 147.99 77.9187 148.657 78.2787 149.19C78.4274 148.955 78.6543 148.72 78.9986 148.523V148.531Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9982 149.763L91.5424 142.5C92.6145 141.88 94.2344 141.809 95.1656 142.351L108.234 149.912C108.398 150.006 108.516 150.116 108.618 150.234C109.032 149.692 108.923 149.073 108.234 148.681L95.1656 141.119C94.2344 140.578 92.6145 140.648 91.5424 141.268L78.9982 148.531C78.1139 149.041 77.8948 149.771 78.3565 150.312C78.5052 150.116 78.7165 149.936 78.9982 149.771V149.763Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4826 151.677C78.6235 151.536 78.7878 151.394 78.9991 151.269L91.5433 144.006C92.6154 143.386 94.2352 143.315 95.1665 143.857L108.235 151.418C108.337 151.473 108.415 151.536 108.493 151.606C109.041 151.034 108.978 150.343 108.235 149.912L95.1665 142.351C94.2352 141.809 92.6154 141.88 91.5433 142.5L78.9991 149.763C78.0444 150.32 77.8487 151.128 78.4826 151.677Z",
    fill: "#18D0F7"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1972 144.343C86.8282 144.343 87.3397 143.83 87.3397 143.198C87.3397 142.565 86.8282 142.052 86.1972 142.052C85.5662 142.052 85.0547 142.565 85.0547 143.198C85.0547 143.83 85.5662 144.343 86.1972 144.343Z",
    fill: "#6DE0F6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8216 137.464C95.9021 137.464 96.778 136.586 96.778 135.503C96.778 134.42 95.9021 133.542 94.8216 133.542C93.7411 133.542 92.8652 134.42 92.8652 135.503C92.8652 136.586 93.7411 137.464 94.8216 137.464Z",
    fill: "#6DE0F6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9196 134.256C92.9196 134.53 92.6927 134.758 92.4188 134.758C92.1449 134.758 91.918 134.53 91.918 134.256C91.918 133.981 92.1449 133.754 92.4188 133.754C92.6927 133.754 92.9196 133.981 92.9196 134.256Z",
    fill: "#6DE0F6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M101.927 124.412C101.927 124.953 101.489 125.392 100.949 125.392C100.409 125.392 99.9707 124.953 99.9707 124.412C99.9707 123.87 100.409 123.431 100.949 123.431C101.489 123.431 101.927 123.87 101.927 124.412Z",
    fill: "#6DE0F6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4886 116.097C96.4886 116.481 96.1756 116.787 95.8 116.787C95.4243 116.787 95.1113 116.474 95.1113 116.097C95.1113 115.721 95.4243 115.407 95.8 115.407C96.1756 115.407 96.4886 115.721 96.4886 116.097Z",
    fill: "#6DE0F6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5918 110.795C88.5918 111.485 88.0284 112.05 87.3397 112.05C86.6511 112.05 86.0876 111.485 86.0876 110.795C86.0876 110.104 86.6511 109.54 87.3397 109.54C88.0284 109.54 88.5918 110.104 88.5918 110.795Z",
    fill: "#6DE0F6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7779 101.908C96.7779 103.312 95.6432 104.449 94.2425 104.449C92.8417 104.449 91.707 103.312 91.707 101.908C91.707 100.503 92.8417 99.3661 94.2425 99.3661C95.6432 99.3661 96.7779 100.503 96.7779 101.908Z",
    fill: "#6DE0F6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7054 100.292C91.7054 100.676 91.3924 100.99 91.009 100.99C90.6255 100.99 90.3125 100.676 90.3125 100.292C90.3125 99.9073 90.6255 99.5936 91.009 99.5936C91.3924 99.5936 91.7054 99.9073 91.7054 100.292Z",
    fill: "#6DE0F6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1062 104.951C97.1062 105.406 96.7384 105.775 96.2846 105.775C95.8307 105.775 95.4629 105.406 95.4629 104.951C95.4629 104.496 95.8307 104.127 96.2846 104.127C96.7384 104.127 97.1062 104.496 97.1062 104.951Z",
    fill: "#6DE0F6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7163 103.233C97.7163 103.453 97.5363 103.633 97.3172 103.633C97.098 103.633 96.9181 103.453 96.9181 103.233C96.9181 103.014 97.098 102.833 97.3172 102.833C97.5363 102.833 97.7163 103.014 97.7163 103.233Z",
    fill: "#6DE0F6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M102.881 94.6676C102.881 95.303 102.364 95.8207 101.73 95.8207C101.097 95.8207 100.58 95.303 100.58 94.6676C100.58 94.0323 101.097 93.5146 101.73 93.5146C102.364 93.5146 102.881 94.0323 102.881 94.6676Z",
    fill: "#6DE0F6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9957 170.314C74.1885 170.314 75.1555 169.345 75.1555 168.149C75.1555 166.953 74.1885 165.984 72.9957 165.984C71.8028 165.984 70.8358 166.953 70.8358 168.149C70.8358 169.345 71.8028 170.314 72.9957 170.314Z",
    fill: "#6DE0F6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.4553 175.875C78.8686 175.875 80.0142 174.727 80.0142 173.31C80.0142 171.894 78.8686 170.745 77.4553 170.745C76.0421 170.745 74.8964 171.894 74.8964 173.31C74.8964 174.727 76.0421 175.875 77.4553 175.875Z",
    fill: "#6DE0F6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M73.3719 174.683C73.3719 175.161 72.9885 175.546 72.5111 175.546C72.0338 175.546 71.6503 175.161 71.6503 174.683C71.6503 174.204 72.0338 173.82 72.5111 173.82C72.9885 173.82 73.3719 174.204 73.3719 174.683Z",
    fill: "#6DE0F6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M77.4559 170.965C77.4559 171.443 77.0724 171.828 76.5951 171.828C76.1177 171.828 75.7343 171.443 75.7343 170.965C75.7343 170.486 76.1177 170.102 76.5951 170.102C77.0724 170.102 77.4559 170.486 77.4559 170.965Z",
    fill: "#6DE0F6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1404 185.327C85.7541 185.327 86.2516 184.828 86.2516 184.213C86.2516 183.598 85.7541 183.099 85.1404 183.099C84.5267 183.099 84.0292 183.598 84.0292 184.213C84.0292 184.828 84.5267 185.327 85.1404 185.327Z",
    fill: "#6DE0F6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.1979 181.946C78.1358 181.946 78.8961 181.184 78.8961 180.244C78.8961 179.304 78.1358 178.542 77.1979 178.542C76.2601 178.542 75.4998 179.304 75.4998 180.244C75.4998 181.184 76.2601 181.946 77.1979 181.946Z",
    fill: "#6DE0F6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.0094 177.248C86.0094 178.189 85.2503 178.95 84.3113 178.95C83.3722 178.95 82.6132 178.189 82.6132 177.248C82.6132 176.307 83.3722 175.546 84.3113 175.546C85.2503 175.546 86.0094 176.307 86.0094 177.248Z",
    fill: "#6DE0F6"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.753 169.177C115.691 169.177 116.451 168.414 116.451 167.474C116.451 166.534 115.691 165.772 114.753 165.772C113.815 165.772 113.055 166.534 113.055 167.474C113.055 168.414 113.815 169.177 114.753 169.177Z",
    fill: "#6DE0F6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M117.428 173.13C117.428 174.463 116.348 175.546 115.018 175.546C113.687 175.546 112.607 174.463 112.607 173.13C112.607 171.796 113.687 170.714 115.018 170.714C116.348 170.714 117.428 171.796 117.428 173.13Z",
    fill: "#6DE0F6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M111.404 171.224C111.404 171.82 110.927 172.298 110.332 172.298C109.737 172.298 109.26 171.82 109.26 171.224C109.26 170.628 109.737 170.149 110.332 170.149C110.927 170.149 111.404 170.628 111.404 171.224Z",
    fill: "#6DE0F6"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M110.283 168.965C110.181 169.937 109.313 170.651 108.342 170.549C107.372 170.447 106.66 169.577 106.762 168.604C106.863 167.631 107.732 166.918 108.702 167.019C109.673 167.121 110.385 167.992 110.283 168.965Z",
    fill: "#6DE0F6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.692 180.119C112.63 180.119 113.39 179.357 113.39 178.417C113.39 177.477 112.63 176.714 111.692 176.714C110.754 176.714 109.994 177.477 109.994 178.417C109.994 179.357 110.754 180.119 111.692 180.119Z",
    fill: "#6DE0F6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M103.139 185.868C103.139 186.566 102.575 187.131 101.879 187.131C101.182 187.131 100.619 186.566 100.619 185.868C100.619 185.17 101.182 184.605 101.879 184.605C102.575 184.605 103.139 185.17 103.139 185.868Z",
    fill: "#6DE0F6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M105.48 183.523C106.66 183.523 107.616 182.564 107.616 181.382C107.616 180.199 106.66 179.24 105.48 179.24C104.3 179.24 103.344 180.199 103.344 181.382C103.344 182.564 104.3 183.523 105.48 183.523Z",
    fill: "#6DE0F6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.408 175.012C104.408 175.954 103.649 176.714 102.71 176.714C101.771 176.714 101.012 175.954 101.012 175.012C101.012 174.071 101.771 173.31 102.71 173.31C103.649 173.31 104.408 174.071 104.408 175.012Z",
    fill: "#6DE0F6"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.9983 191.641C94.4029 191.641 95.5415 190.5 95.5415 189.092C95.5415 187.684 94.4029 186.543 92.9983 186.543C91.5936 186.543 90.455 187.684 90.455 189.092C90.455 190.5 91.5936 191.641 92.9983 191.641Z",
    fill: "#6DE0F6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2392 173.31C84.1771 173.31 84.9373 172.548 84.9373 171.608C84.9373 170.668 84.1771 169.906 83.2392 169.906C82.3014 169.906 81.5411 170.668 81.5411 171.608C81.5411 172.548 82.3014 173.31 83.2392 173.31Z",
    fill: "#6DE0F6"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.0181 264.785C93.7409 264.785 91.4637 264.276 89.6951 263.248L37.5228 233.183C35.5117 232.022 34.3691 230.304 34.3691 228.468C34.3691 226.633 35.5195 224.915 37.5228 223.754L66.344 207.008C67.2126 206.498 68.3316 206.796 68.8403 207.674C69.3489 208.545 69.0516 209.667 68.1751 210.176L39.354 226.923C38.5166 227.409 38.0236 227.982 38.0236 228.468C38.0236 228.955 38.5166 229.535 39.354 230.014L91.5263 260.079C93.9678 261.491 98.084 261.491 100.526 260.079L129.456 243.442C130.333 242.94 131.444 243.238 131.945 244.117C132.446 244.995 132.14 246.109 131.272 246.611L102.341 263.248C100.572 264.276 98.2953 264.785 96.0259 264.785H96.0181Z",
    fill: "#6EE8FC"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0176 263.319C93.9908 263.319 91.964 262.872 90.4224 261.977L38.2501 231.912C36.685 231.01 35.8242 229.786 35.8242 228.46C35.8242 227.135 36.685 225.919 38.2501 225.017L67.0713 208.27L67.4391 208.898L38.6179 225.645C37.2876 226.413 36.5598 227.409 36.5598 228.46C36.5598 229.512 37.2876 230.508 38.6179 231.276L90.7902 261.342C93.6778 263.013 98.3653 263.013 101.245 261.342L130.176 244.705L130.536 245.34L101.605 261.977C100.063 262.872 98.0366 263.319 96.0098 263.319H96.0176Z",
    fill: "#6EE8FC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6351 213.596C58.1812 212.812 58.4551 211.8 59.2533 211.337C60.0437 210.875 61.061 211.141 61.5149 211.926C61.9688 212.71 61.6949 213.722 60.8967 214.185C60.1063 214.647 59.089 214.381 58.6351 213.596Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0122 218.609C49.5584 217.824 49.8323 216.812 50.6305 216.35C51.4286 215.887 52.4381 216.153 52.892 216.938C53.3459 217.722 53.072 218.734 52.2738 219.197C51.4834 219.66 50.4661 219.393 50.0122 218.609Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M41.389 223.613C40.9351 222.829 41.209 221.817 42.0072 221.354C42.7976 220.891 43.8149 221.158 44.2688 221.942C44.7227 222.727 44.4488 223.738 43.6506 224.201C42.8602 224.664 41.8429 224.397 41.389 223.613Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2333 230.688C36.9202 231.002 36.4742 231.182 36.0047 231.057C35.5273 230.963 35.0265 230.516 34.7761 229.833C34.5491 229.127 34.7056 228.398 35.0656 228.006C35.4178 227.605 35.8951 227.535 36.3177 227.668C36.7559 227.809 37.0924 228.092 37.3663 228.288C37.6402 228.5 37.8436 228.61 37.8828 228.782C37.961 228.955 37.8828 229.245 37.8123 229.598C37.7028 229.951 37.5541 230.359 37.2333 230.688Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7634 235.826C45.3095 236.61 44.3 236.877 43.5096 236.422C42.7114 235.967 42.4375 234.955 42.8836 234.171C43.3375 233.386 44.347 233.12 45.1373 233.575C45.9277 234.03 46.2094 235.041 45.7634 235.826Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M54.402 240.799C53.9482 241.583 52.9387 241.85 52.1483 241.395C51.3501 240.94 51.0762 239.928 51.5223 239.144C51.9761 238.359 52.9856 238.093 53.776 238.548C54.5742 239.003 54.8481 240.014 54.402 240.799Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0407 245.78C62.5868 246.564 61.5773 246.831 60.787 246.376C59.9888 245.921 59.7149 244.909 60.1609 244.125C60.6148 243.34 61.6243 243.074 62.4147 243.529C63.205 243.983 63.4868 244.995 63.0407 245.78Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6813 250.761C71.2275 251.545 70.218 251.812 69.4276 251.357C68.6294 250.902 68.3555 249.89 68.8016 249.106C69.2554 248.321 70.2649 248.054 71.0553 248.509C71.8535 248.964 72.1274 249.976 71.6813 250.761Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M124.589 248.345C125.043 249.129 124.761 250.141 123.963 250.596C123.165 251.051 122.155 250.784 121.709 250C121.255 249.215 121.537 248.204 122.335 247.749C123.134 247.294 124.143 247.56 124.589 248.345Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M212.688 210.247L187.232 195.516C185.424 194.465 185.651 192.638 187.74 191.43L212.179 177.287C214.269 176.079 217.43 175.946 219.238 176.997L244.694 191.728C246.502 192.779 246.275 194.606 244.185 195.814L219.746 209.957C217.657 211.165 214.495 211.298 212.688 210.247Z",
    fill: "#0C0F38"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M215.716 214.334C214.308 214.334 212.962 214.051 211.952 213.471L181.965 196.12C180.94 195.524 180.377 194.693 180.377 193.767C180.377 192.677 181.175 191.586 182.56 190.786L211.35 174.126C213.893 172.651 217.759 172.502 219.966 173.781L249.953 191.132C250.978 191.728 251.541 192.559 251.541 193.485C251.541 194.575 250.743 195.665 249.358 196.465L220.568 213.126C219.183 213.926 217.399 214.334 215.709 214.334H215.716ZM212.258 212.945C214.3 214.13 217.9 213.973 220.279 212.6L249.069 195.94C250.266 195.25 250.955 194.348 250.955 193.477C250.955 192.779 250.493 192.128 249.663 191.649L219.676 174.299C217.634 173.114 214.034 173.271 211.663 174.644L182.873 191.304C181.676 191.994 180.987 192.896 180.987 193.767C180.987 194.465 181.441 195.116 182.278 195.595L212.265 212.945H212.258Z",
    fill: "url(#paint35_linear_1_392)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M245.922 178.675H233.3L219.245 170.541C217.438 169.49 214.276 169.624 212.187 170.832L198.641 178.668H186.026V187.163C185.971 187.868 186.371 188.559 187.239 189.061L212.695 203.792C214.503 204.843 217.665 204.709 219.754 203.501L244.193 189.359C245.281 188.731 245.86 187.931 245.914 187.17H245.922V178.675Z",
    fill: "url(#paint36_linear_1_392)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M244.193 188.771L219.754 202.913C217.665 204.121 214.503 204.254 212.695 203.203L187.239 188.472C186.371 187.97 185.971 187.288 186.026 186.574V187.163C185.971 187.868 186.371 188.559 187.239 189.061L212.695 203.792C214.503 204.843 217.665 204.709 219.754 203.501L244.193 189.359C245.281 188.731 245.86 187.931 245.914 187.17H245.922V186.582H245.914C245.86 187.351 245.281 188.143 244.193 188.771Z",
    fill: "url(#paint37_linear_1_392)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M186.817 187.751V179.256H199.431L212.977 171.42C215.066 170.212 218.228 170.079 220.036 171.13L234.09 179.264H245.914V178.675H233.292L219.237 170.541C217.43 169.49 214.268 169.624 212.179 170.832L198.633 178.668H186.018V187.163C185.964 187.868 186.363 188.559 187.231 189.061L187.372 189.147C186.965 188.731 186.777 188.245 186.817 187.751Z",
    fill: "#D4088C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M245.202 179.35V187.806H245.194C245.163 188.237 244.959 188.684 244.592 189.1C245.421 188.52 245.859 187.829 245.914 187.163H245.922V178.754C245.664 178.926 245.421 179.115 245.202 179.35Z",
    fill: "#6EE8FC"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M212.688 195.297L187.232 180.566C185.424 179.515 185.651 177.687 187.74 176.479L212.179 162.337C214.269 161.129 217.43 160.995 219.238 162.046L244.694 176.777C246.502 177.828 246.275 179.656 244.185 180.864L219.746 195.006C217.657 196.214 214.495 196.348 212.688 195.297Z",
    fill: "url(#paint38_radial_1_392)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M244.695 176.777L219.239 162.046C218.3 161.505 217.001 161.278 215.678 161.356C216.641 161.411 217.549 161.639 218.245 162.046L243.701 176.777C245.509 177.828 245.282 179.656 243.193 180.864L218.754 195.006C217.744 195.587 216.492 195.916 215.256 195.987C216.782 196.081 218.472 195.744 219.747 195.006L244.186 180.864C246.276 179.656 246.503 177.828 244.695 176.777Z",
    fill: "#6EE8FC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M215.81 191.79C214.918 191.79 214.057 191.61 213.424 191.241L194.47 180.276C193.813 179.891 193.453 179.358 193.453 178.762C193.453 178.064 193.962 177.366 194.846 176.856L213.04 166.321C214.652 165.388 217.109 165.294 218.518 166.102L237.471 177.067C238.129 177.452 238.489 177.985 238.489 178.581C238.489 179.279 237.98 179.978 237.096 180.487L218.901 191.014C218.025 191.524 216.89 191.783 215.818 191.783L215.81 191.79ZM216.123 165.976C215.13 165.976 214.081 166.219 213.259 166.698L195.065 177.232C194.314 177.664 193.883 178.221 193.883 178.762C193.883 179.193 194.165 179.593 194.682 179.891L213.635 190.857C214.918 191.602 217.18 191.5 218.675 190.637L236.869 180.111C237.62 179.679 238.05 179.123 238.05 178.581C238.05 178.15 237.769 177.75 237.252 177.452L218.299 166.486C217.72 166.149 216.945 165.984 216.123 165.984V165.976Z",
    fill: "#480689"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M213.83 195.297L188.374 180.566C186.566 179.515 186.793 177.687 188.883 176.479L213.322 162.337C214.315 161.764 215.544 161.435 216.765 161.356C215.215 161.246 213.486 161.576 212.179 162.337L187.74 176.479C185.651 177.687 185.424 179.515 187.232 180.566L212.688 195.297C213.635 195.846 214.965 196.065 216.311 195.979C215.38 195.916 214.511 195.689 213.83 195.297Z",
    fill: "#D4088C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M274.641 174.965L249.185 160.235C247.377 159.183 247.604 157.356 249.694 156.148L274.132 142.005C276.222 140.797 279.383 140.664 281.191 141.715L306.647 156.446C308.455 157.497 308.228 159.325 306.139 160.533L281.7 174.675C279.61 175.883 276.449 176.016 274.641 174.965Z",
    fill: "#0C0F38"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M277.67 179.052C276.261 179.052 274.915 178.77 273.906 178.181L243.919 160.831C242.894 160.235 242.33 159.403 242.33 158.477C242.33 157.387 243.128 156.297 244.513 155.497L273.303 138.836C275.846 137.362 279.712 137.213 281.919 138.491L311.906 155.842C312.931 156.438 313.495 157.27 313.495 158.195C313.495 159.285 312.697 160.376 311.311 161.176L282.522 177.836C281.136 178.636 279.352 179.052 277.662 179.052H277.67ZM278.163 138.217C276.582 138.217 274.907 138.601 273.608 139.362L244.819 156.022C243.621 156.713 242.933 157.615 242.933 158.485C242.933 159.183 243.387 159.834 244.224 160.313L274.211 177.664C276.253 178.848 279.853 178.691 282.232 177.318L311.022 160.658C312.219 159.968 312.908 159.066 312.908 158.195C312.908 157.497 312.446 156.846 311.617 156.368L281.63 139.017C280.706 138.483 279.47 138.225 278.171 138.225L278.163 138.217Z",
    fill: "url(#paint39_linear_1_392)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M307.868 143.394H295.245L281.191 135.26C279.383 134.209 276.222 134.342 274.132 135.55L260.586 143.386H247.972V151.881C247.917 152.587 248.316 153.277 249.185 153.779L274.641 168.51C276.449 169.561 279.61 169.428 281.699 168.22L306.138 154.077C307.226 153.45 307.805 152.65 307.86 151.889H307.868V143.394Z",
    fill: "url(#paint40_linear_1_392)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M306.138 153.497L281.699 167.639C279.61 168.847 276.449 168.98 274.641 167.929L249.185 153.199C248.316 152.697 247.917 152.014 247.972 151.3V151.889C247.917 152.595 248.316 153.285 249.185 153.787L274.641 168.518C276.449 169.569 279.61 169.435 281.699 168.227L306.138 154.085C307.226 153.457 307.805 152.657 307.86 151.896H307.868V151.308H307.86C307.805 152.077 307.226 152.869 306.138 153.497Z",
    fill: "url(#paint41_linear_1_392)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M248.77 152.477V143.982H261.385L274.93 136.146C277.02 134.938 280.181 134.805 281.989 135.856L296.044 143.99H307.868V143.402H295.245L281.191 135.267C279.383 134.216 276.222 134.35 274.132 135.558L260.586 143.394H247.972V151.889C247.917 152.595 248.316 153.285 249.185 153.787L249.326 153.873C248.919 153.457 248.731 152.971 248.77 152.477Z",
    fill: "#D4088C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M307.155 144.076V152.532H307.147C307.116 152.963 306.913 153.41 306.545 153.826C307.374 153.246 307.813 152.555 307.867 151.889H307.875V143.48C307.617 143.653 307.374 143.841 307.155 144.076Z",
    fill: "#6EE8FC"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M274.641 160.023L249.185 145.292C247.377 144.241 247.604 142.413 249.694 141.205L274.132 127.063C276.222 125.855 279.383 125.722 281.191 126.773L306.647 141.503C308.455 142.554 308.228 144.382 306.139 145.59L281.7 159.733C279.61 160.94 276.449 161.074 274.641 160.023Z",
    fill: "url(#paint42_radial_1_392)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M306.648 141.496L281.192 126.765C280.253 126.224 278.954 125.996 277.632 126.074C278.594 126.129 279.502 126.357 280.198 126.765L305.655 141.496C307.462 142.547 307.235 144.374 305.146 145.582L280.707 159.725C279.697 160.305 278.445 160.635 277.209 160.705C278.735 160.799 280.417 160.462 281.701 159.725L306.14 145.582C308.229 144.374 308.456 142.547 306.648 141.496Z",
    fill: "#6EE8FC"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M277.756 156.517C276.856 156.517 276.003 156.336 275.361 155.967L256.408 145.002C255.751 144.617 255.391 144.084 255.391 143.488C255.391 142.79 255.899 142.092 256.784 141.574L274.978 131.048C276.59 130.114 279.047 130.012 280.456 130.828L299.409 141.794C300.066 142.178 300.426 142.711 300.426 143.307C300.426 144.006 299.918 144.704 299.033 145.221L280.839 155.748C279.963 156.258 278.828 156.517 277.756 156.517ZM275.58 155.591C276.864 156.336 279.125 156.234 280.62 155.371L298.814 144.845C299.565 144.413 299.996 143.857 299.996 143.315C299.996 142.884 299.714 142.484 299.198 142.186L280.244 131.22C278.961 130.475 276.699 130.569 275.205 131.44L257.011 141.966C256.259 142.398 255.829 142.954 255.829 143.496C255.829 143.927 256.111 144.327 256.627 144.625L275.58 155.591Z",
    fill: "#480689"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M275.784 160.023L250.327 145.292C248.52 144.241 248.747 142.413 250.836 141.205L275.275 127.063C276.269 126.49 277.497 126.161 278.718 126.082C277.169 125.973 275.439 126.302 274.132 127.063L249.694 141.205C247.604 142.413 247.377 144.241 249.185 145.292L274.641 160.023C275.588 160.572 276.918 160.791 278.264 160.705C277.333 160.642 276.464 160.415 275.784 160.023Z",
    fill: "#D4088C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.571 246.878L126.115 232.147C124.307 231.096 124.534 229.268 126.623 228.06L151.062 213.918C153.152 212.71 156.313 212.577 158.121 213.628L183.577 228.359C185.385 229.41 185.158 231.237 183.068 232.445L158.63 246.588C156.54 247.796 153.379 247.929 151.571 246.878Z",
    fill: "#0C0F38"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M154.6 250.965C153.191 250.965 151.845 250.682 150.836 250.102L120.848 232.751C119.823 232.155 119.26 231.324 119.26 230.398C119.26 229.308 120.058 228.217 121.443 227.417L150.233 210.757C152.776 209.282 156.642 209.133 158.849 210.412L188.836 227.762C189.861 228.359 190.425 229.19 190.425 230.116C190.425 231.206 189.626 232.296 188.241 233.096L159.451 249.757C158.066 250.557 156.282 250.972 154.592 250.972L154.6 250.965ZM151.141 249.576C153.183 250.761 156.783 250.604 159.162 249.231L187.952 232.571C189.149 231.88 189.838 230.978 189.838 230.108C189.838 229.41 189.384 228.759 188.546 228.28L158.559 210.929C156.517 209.745 152.917 209.902 150.546 211.275L121.756 227.935C120.559 228.625 119.87 229.527 119.87 230.398C119.87 231.096 120.332 231.747 121.162 232.226L151.149 249.576H151.141Z",
    fill: "url(#paint43_linear_1_392)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M184.805 215.306H172.183L158.128 207.172C156.321 206.121 153.159 206.254 151.07 207.462L137.524 215.298H124.909V223.793C124.855 224.499 125.254 225.19 126.122 225.692L151.579 240.422C153.386 241.473 156.548 241.34 158.637 240.132L183.076 225.99C184.164 225.362 184.743 224.562 184.798 223.801H184.805V215.306Z",
    fill: "url(#paint44_linear_1_392)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M183.076 225.401L158.637 239.544C156.548 240.752 153.386 240.885 151.579 239.834L126.122 225.103C125.254 224.601 124.855 223.919 124.909 223.205V223.793C124.855 224.499 125.254 225.19 126.122 225.692L151.579 240.422C153.386 241.473 156.548 241.34 158.637 240.132L183.076 225.99C184.164 225.362 184.743 224.562 184.798 223.801H184.805V223.213H184.798C184.743 223.982 184.164 224.774 183.076 225.401Z",
    fill: "url(#paint45_linear_1_392)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 224.382V215.887H138.314L151.86 208.051C153.95 206.843 157.111 206.709 158.919 207.761L172.973 215.895H184.798V215.306H172.175L158.121 207.172C156.313 206.121 153.151 206.254 151.062 207.462L137.516 215.298H124.902V223.793C124.847 224.499 125.246 225.19 126.115 225.692L126.255 225.778C125.848 225.362 125.661 224.876 125.7 224.382Z",
    fill: "#D4088C"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M184.085 215.989V224.444H184.077C184.046 224.876 183.843 225.323 183.475 225.739C184.304 225.158 184.742 224.468 184.797 223.801H184.805V215.393C184.547 215.565 184.304 215.753 184.085 215.989Z",
    fill: "#6EE8FC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M151.571 231.935L126.115 217.205C124.307 216.153 124.534 214.326 126.623 213.118L151.062 198.975C153.152 197.767 156.313 197.634 158.121 198.685L183.577 213.416C185.385 214.467 185.158 216.295 183.068 217.503L158.63 231.645C156.54 232.853 153.379 232.986 151.571 231.935Z",
    fill: "url(#paint46_radial_1_392)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M183.586 213.408L158.13 198.677C157.191 198.136 155.892 197.909 154.569 197.987C155.532 198.042 156.44 198.269 157.136 198.677L182.592 213.408C184.4 214.459 184.173 216.287 182.084 217.495L157.645 231.637C156.635 232.218 155.383 232.547 154.147 232.618C155.673 232.712 157.363 232.375 158.638 231.637L183.077 217.495C185.167 216.287 185.394 214.459 183.586 213.408Z",
    fill: "#6EE8FC"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M152.409 227.684L133.455 216.718C132.109 215.942 132.274 214.577 133.831 213.675L152.025 203.14C153.582 202.238 155.938 202.144 157.284 202.921L176.237 213.887C177.583 214.663 177.419 216.028 175.861 216.93L157.667 227.464C156.11 228.366 153.755 228.46 152.409 227.684Z",
    fill: "url(#paint47_linear_1_392)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M153.081 224.272L139.347 216.326C138.369 215.761 138.494 214.773 139.621 214.122L152.807 206.49C153.934 205.839 155.64 205.768 156.618 206.333L170.352 214.279C171.33 214.844 171.205 215.832 170.078 216.483L156.892 224.115C155.765 224.766 154.059 224.837 153.081 224.272Z",
    fill: "#6DE0F6"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M152.713 231.935L127.257 217.205C125.45 216.153 125.677 214.326 127.766 213.118L152.205 198.975C153.199 198.403 154.427 198.073 155.648 197.995C154.099 197.885 152.369 198.222 151.062 198.975L126.623 213.118C124.534 214.326 124.307 216.153 126.115 217.205L151.571 231.935C152.518 232.484 153.848 232.704 155.194 232.618C154.263 232.547 153.394 232.328 152.713 231.935Z",
    fill: "#D4088C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 205,
    width: 34,
    height: 20
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M153.081 224.272L139.347 216.326C138.369 215.761 138.494 214.773 139.621 214.122L152.807 206.49C153.934 205.839 155.64 205.768 156.618 206.333L170.352 214.279C171.33 214.844 171.205 215.832 170.078 216.483L156.892 224.115C155.765 224.766 154.059 224.837 153.081 224.272Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.621 215.197L152.807 207.564C153.934 206.913 155.64 206.843 156.618 207.408L170.352 215.353C170.571 215.479 170.72 215.628 170.829 215.785C171.158 215.244 171.017 214.663 170.352 214.279L156.618 206.333C155.64 205.768 153.934 205.839 152.807 206.49L139.621 214.122C138.745 214.632 138.486 215.338 138.87 215.895C139.019 215.644 139.269 215.4 139.621 215.197Z",
    fill: "#267FE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.622 216.499L152.808 208.866C153.935 208.215 155.641 208.145 156.619 208.71L170.353 216.655C170.525 216.757 170.65 216.867 170.752 216.993C171.19 216.42 171.073 215.777 170.353 215.361L156.619 207.415C155.641 206.851 153.935 206.921 152.808 207.572L139.622 215.204C138.691 215.746 138.456 216.506 138.949 217.071C139.106 216.867 139.325 216.671 139.622 216.499Z",
    fill: "#25BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.074 218.507C139.215 218.358 139.395 218.209 139.614 218.083L152.8 210.451C153.927 209.8 155.633 209.729 156.611 210.294L170.344 218.24C170.446 218.303 170.532 218.365 170.611 218.436C171.19 217.832 171.127 217.11 170.344 216.655L156.611 208.71C155.633 208.145 153.927 208.215 152.8 208.867L139.614 216.499C138.604 217.079 138.409 217.926 139.074 218.507Z",
    fill: "#18D0F7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.4,
    d: "M171.009 192.285H138.697V215.377C138.697 215.738 138.917 216.075 139.355 216.334L153.088 224.28C154.067 224.844 155.773 224.774 156.899 224.123L170.085 216.491C170.672 216.153 170.985 215.722 171.017 215.314V192.292L171.009 192.285Z",
    fill: "url(#paint48_linear_1_392)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2,
    d: "M170.893 146.861H138.801V215.432C138.801 215.785 139.02 216.122 139.45 216.381L153.082 224.272C154.053 224.837 155.743 224.766 156.862 224.115L169.954 216.538C170.533 216.201 170.846 215.777 170.877 215.369V146.861H170.893Z",
    fill: "url(#paint49_linear_1_392)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.25,
    d: "M169.374 153.403H140.334V215.463C140.334 215.785 140.53 216.091 140.921 216.318L153.262 223.456C154.138 223.966 155.672 223.903 156.681 223.315L168.529 216.459C169.053 216.153 169.335 215.769 169.366 215.4V153.403H169.374Z",
    fill: "url(#paint50_linear_1_392)"
  }), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M147.236 210.89C147.898 210.89 148.434 210.353 148.434 209.69C148.434 209.027 147.898 208.49 147.236 208.49C146.575 208.49 146.039 209.027 146.039 209.69C146.039 210.353 146.575 210.89 147.236 210.89Z",
    fill: "#6DE0F6"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M156.243 203.705C157.371 203.705 158.286 202.789 158.286 201.658C158.286 200.527 157.371 199.611 156.243 199.611C155.115 199.611 154.201 200.527 154.201 201.658C154.201 202.789 155.115 203.705 156.243 203.705Z",
    fill: "#6DE0F6"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M154.256 200.356C154.256 200.646 154.021 200.881 153.731 200.881C153.442 200.881 153.207 200.646 153.207 200.356C153.207 200.066 153.442 199.83 153.731 199.83C154.021 199.83 154.256 200.066 154.256 200.356Z",
    fill: "#6DE0F6"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M162.644 191.108C163.206 191.108 163.662 190.651 163.662 190.088C163.662 189.525 163.206 189.069 162.644 189.069C162.082 189.069 161.627 189.525 161.627 190.088C161.627 190.651 162.082 191.108 162.644 191.108Z",
    fill: "#6DE0F6"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M157.269 182.127C157.666 182.127 157.989 181.804 157.989 181.405C157.989 181.007 157.666 180.683 157.269 180.683C156.871 180.683 156.549 181.007 156.549 181.405C156.549 181.804 156.871 182.127 157.269 182.127Z",
    fill: "#6DE0F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265.377 287.021) rotate(30.0583) scale(59.1405 51.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.979 233.598) rotate(30.0583) scale(59.1405 51.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.908 177.521) rotate(30.0583) scale(59.1405 51.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_392",
    x1: 85.9305,
    y1: 160.368,
    x2: 155.358,
    y2: 160.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_392",
    x1: 85.9299,
    y1: 168.337,
    x2: 155.357,
    y2: 168.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_392",
    x1: 406.397,
    y1: 334.863,
    x2: 448.95,
    y2: 326.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D139B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#841BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6D32B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4958CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2979E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_392",
    x1: 411.947,
    y1: 333.792,
    x2: 443.63,
    y2: 327.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_392",
    x1: -0.000797795,
    y1: 142.735,
    x2: 0.781748,
    y2: 142.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_392",
    x1: -0.00146286,
    y1: 150.704,
    x2: 0.781083,
    y2: 150.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_392",
    x1: 398.781,
    y1: 312.821,
    x2: 441.333,
    y2: 304.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D139B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#841BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6D32B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4958CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2979E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_392",
    x1: 404.331,
    y1: 311.749,
    x2: 436.01,
    y2: 305.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_392",
    x1: -0.000797795,
    y1: 112.497,
    x2: 0.781748,
    y2: 112.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_392",
    x1: 85.9299,
    y1: 120.466,
    x2: 155.357,
    y2: 120.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_392",
    x1: 385.72,
    y1: 275.02,
    x2: 428.268,
    y2: 266.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D139B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#841BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6D32B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4958CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2979E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_392",
    x1: 391.266,
    y1: 273.955,
    x2: 422.949,
    y2: 267.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_392",
    x1: -0.000797795,
    y1: 81.937,
    x2: 0.781748,
    y2: 81.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_392",
    x1: -0.00146286,
    y1: 89.8986,
    x2: 0.781083,
    y2: 89.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.69 60.5873) scale(61.697 61.6696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_392",
    x1: 378.064,
    y1: 235.756,
    x2: 409.747,
    y2: 229.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_392",
    x1: 119.815,
    y1: 82.745,
    x2: 119.815,
    y2: 8.23606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.085 173.986) scale(30.8245 66.9945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_392",
    x1: 59.6063,
    y1: 204.584,
    x2: 129.034,
    y2: 204.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_392",
    x1: 59.6057,
    y1: 212.553,
    x2: 129.033,
    y2: 212.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3658 183.242) scale(61.697 61.6695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_392",
    x1: 411.306,
    y1: 392.872,
    x2: 442.982,
    y2: 386.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_392",
    x1: 59.6063,
    y1: 186.951,
    x2: 129.034,
    y2: 186.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_392",
    x1: 59.6057,
    y1: 194.92,
    x2: 129.033,
    y2: 194.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_392",
    x1: 398.143,
    y1: 371.895,
    x2: 440.692,
    y2: 363.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D139B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#841BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6D32B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4958CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2979E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_392",
    x1: 403.689,
    y1: 370.83,
    x2: 435.366,
    y2: 364.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_392",
    x1: 59.6063,
    y1: 156.713,
    x2: 129.034,
    y2: 156.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_392",
    x1: 59.6057,
    y1: 164.682,
    x2: 129.033,
    y2: 164.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.3658 135.371) scale(61.697 61.6696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_392",
    x1: 390.628,
    y1: 333.029,
    x2: 422.301,
    y2: 326.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_392",
    x1: 93.4827,
    y1: 157.528,
    x2: 93.4827,
    y2: 83.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_392",
    x1: 93.482,
    y1: 156.713,
    x2: 93.482,
    y2: 89.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#70E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5AB5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4483A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#325A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#243A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B234D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#151541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_392",
    x1: 212.758,
    y1: 173.318,
    x2: 219.205,
    y2: 213.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4088C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_392",
    x1: 180.345,
    y1: 187.17,
    x2: 253.333,
    y2: 187.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_392",
    x1: 180.345,
    y1: 195.54,
    x2: 253.333,
    y2: 195.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.246 164.732) scale(64.8585 64.8158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_392",
    x1: 274.704,
    y1: 138.036,
    x2: 281.15,
    y2: 178.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4088C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_392",
    x1: 242.298,
    y1: 151.889,
    x2: 315.286,
    y2: 151.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_392",
    x1: 242.298,
    y1: 160.266,
    x2: 315.286,
    y2: 160.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.2 129.458) scale(64.8584 64.8158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_392",
    x1: 151.642,
    y1: 209.949,
    x2: 158.088,
    y2: 250.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4088C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_392",
    x1: 119.228,
    y1: 223.801,
    x2: 192.216,
    y2: 223.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A31FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8A16A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#740F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#640A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A068F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#58068E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4D21A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3167D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C75E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_392",
    x1: 119.228,
    y1: 232.178,
    x2: 192.216,
    y2: 232.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D4088C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6EE1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6EE8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EE8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1_392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.13 201.371) scale(64.8584 64.8158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#793CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B23C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_392",
    x1: 464.62,
    y1: 407.649,
    x2: 497.927,
    y2: 401.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#630692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5A0D93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#432299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_392",
    x1: 154.849,
    y1: 224.656,
    x2: 154.849,
    y2: 192.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_392",
    x1: 154.851,
    y1: 224.656,
    x2: 154.851,
    y2: 146.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#25BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#23B4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1E82AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1A5986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#173A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#14234F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_392",
    x1: 154.85,
    y1: 223.809,
    x2: 154.85,
    y2: 153.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#70E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5AB5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4483A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#325A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#243A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B234D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#151541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13113D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControlsImg);
export default __webpack_public_path__ + "static/media/AccessControlsImg.e071d9bda41b8c0355572c08c425eaf0.svg";
export { ForwardRef as ReactComponent };